import { logo_placeholder } from 'src/components/pages/ai-agent-v3/AgentLayoutComponentV2';
import { formatCss } from './formatCss';

export const defaultValuesTextBotV3 = (() => {
    return {
        es: {
            exit_message_action: 'Salir',
            agent_message_action: 'Agente',
            show_less: 'Mostrar menos',
            show_more: 'Mostrar Mas',
            toggle_title: 'Chat',
            header_title: `Hola, soy {agentName}`,
            header_subtitle: '¿Cómo puedo ayudarte hoy?',
            description: '¿Cómo puedo ayudarte hoy?',
            closed_welcome: '¡Bienvenido! ¿En qué podemos ayudarte?',
            header_options_title: 'Opciones',
            header_close_title: 'Cerrar',
            opts_expand: 'Ampliar chat',
            opts_restore: 'Restaurar tamaño',
            opts_finalize: 'Finalizar chat',
            suggestions_title: 'Sugerencias',
            // Onboarding prompts
            pre_submit_loading: 'Iniciando…',
            pre_error_generic: 'No se pudo iniciar el chat 😢. Por favor, inténtalo de nuevo.',
            jump_title: 'Ir al último',
            jump_label: 'Último',
            powered_by: 'Con tecnología IA️. Nuestro asistente de IA puede cometer errores.',
            tool_attach_title: 'Adjuntar archivo',
            tool_mic_title: 'Grabar audio',
            tool_call_title: 'Llamar a un asesor',
            input_placeholder: 'Escribe tu mensaje…',
            send_title: 'Enviar',
            send_aria: 'Enviar',
            welcome_template: '¡Hola {name}! Estás conectado. Envíanos un mensaje y te responderemos.',
            initial_message: 'Hola, necesito tu ayuda.',
            attach_one: 'Archivo adjunto: {name}',
            attach_many: '{count} archivos adjuntos.',
            bot_fixed_reply:
                'Hola. Por ahora nuestros servicios no están disponibles. Por favor, inténtalo nuevamente en 2 horas.',
            mic_not_supported: 'El micrófono no es compatible en este navegador.',
            mic_recorded: 'Mensaje de audio grabado.',
            mic_denied: 'Permiso de micrófono denegado.',
            assessor_notified: 'Un asesor ha sido notificado. Nos pondremos en contacto contigo en breve.',
            // Onboarding questions_session texts
            q1_question: 'Hola, ¿Cuál es tu nombre?',
            q1_panel_description:
                'Para brindarte una experiencia más personalizada, necesitamos tu nombre. Solo se usará para identificarte en el chat y no se compartirá con terceros.',
            q1_error_message:
                'Por favor, ingresa un nombre válido: Nombre y Apellido, solo letras, cada una de máximo 15 caracteres. No escribas saludos como ‘hola’ o ‘hello’.',
            q1_placeholder: 'Ingresa tu nombre',
            q2_question: 'Genial {name}, ¿cuál es tu número de teléfono 📞?',
            q2_panel_description:
                'Esto nos permite contactarte por WhatsApp si es necesario y brindarte una atención más rápida.',
            q2_error_message: 'Por favor, ingresa un número de teléfono válido. Formato: 123-456-7890',
            q2_placeholder: 'Ingresa tu número de teléfono',
            q3_question: '{name} Para Continuar Acepta nuestros terminos y condiciones de uso.',
            q3_panel_description: 'Tu número solo se utilizará para comunicación y no se compartirá con terceros.',
            terms_accept_button: 'Aceptar',
            terms_link_label: 'Aceptar politica y tratamiento de datos',
        },
        en: {
            exit_message_action: 'Exit',
            agent_message_action: 'Agent',
            show_less: 'Show less',
            show_more: 'Show more',
            toggle_title: 'Chat',
            header_title: "Hi, I'm {agentName}",
            header_subtitle: 'How can I help you today?',
            description: 'How can I help you today?',
            closed_welcome: 'Welcome! How can we help you?',
            header_options_title: 'Options',
            header_close_title: 'Close',
            opts_expand: 'Expand chat',
            opts_restore: 'Restore size',
            opts_finalize: 'End chat',
            suggestions_title: 'Suggestions',
            pre_submit_loading: 'Starting…',
            pre_error_generic: 'Could not start the chat 😢. Please try again.',
            jump_title: 'Go to last',
            jump_label: 'Last',
            powered_by: 'Powered by AI. Our AI assistant may make mistakes.',
            tool_attach_title: 'Attach file',
            tool_mic_title: 'Record audio',
            tool_call_title: 'Call an advisor',
            input_placeholder: 'Type your message…',
            send_title: 'Send',
            send_aria: 'Send',
            welcome_template: "Hi {name}! You're connected. Send us a message and we’ll reply.",
            initial_message: 'Hi, I need your help.',
            attach_one: 'Attached file: {name}',
            attach_many: '{count} attached files.',
            bot_fixed_reply: 'Hi. Our services are currently unavailable. Please try again in 2 hours.',
            mic_not_supported: 'The microphone is not supported in this browser.',
            mic_recorded: 'Audio message recorded.',
            mic_denied: 'Microphone permission denied.',
            assessor_notified: 'An advisor has been notified. We will contact you shortly.',

            q1_question: "Hi, what's your name?",
            q1_panel_description:
                "To give you a more personalized experience, we need your name. It will only be used to identify you in the chat and won't be shared with third parties.",
            q1_error_message:
                'Please enter a valid name: First and Last name, letters only, each up to 15 characters. Don’t write greetings like ‘hi’ or ‘hello’.',
            q1_placeholder: 'Enter your name',

            q2_question: "Great {name}, what's your phone number 📞?",
            q2_panel_description: 'This allows us to contact you via WhatsApp if needed and provide faster support.',
            q2_error_message: 'Please enter a valid phone number. Format: 123-456-7890',
            q2_placeholder: 'Enter your phone number',

            q3_question: '{name} To continue, please accept our terms and conditions.',
            q3_panel_description:
                'Your number will only be used for communication and will not be shared with third parties.',

            terms_accept_button: 'Accept',
            terms_link_label: 'Accept data policy and data processing',
        },
    }[localStorage.getItem('crm_locale') ?? 'es'];
})();

function buildTexts(data = {}) {
    return {
        ...Object.fromEntries(Object.entries(defaultValuesTextBotV3).map(([key, value]) => [key, data[key] ?? value])),
        ...(data.initial_bot_message ? { initial_bot_message: data.initial_bot_message } : {}),
    };
}

// Bot.preconnect('https://fonts.googleapis.com');
//             Bot.preconnect('https://fonts.gstatic.com', true);
//             Bot.loadCSS(
//                 'https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400;0,600;1,400&display=swap',
//                 'sbx-bot-font-arimo'
//             );

function botScriptInit(data, containerId) {
    const commonKeys = {
        STORAGE_KEY: 'sbx-bot-session',
        WIDGET_ID: `sbx-bot-widget-${data.agentId}`,
        CSS_URL: `${data.config.urlFiles}css/globalStyles.css`,
        SOUND_PREF_KEY: 'sbx-bot-sound-enabled',
        MESSAGES_PREFIX: `sbx_bot_messages_v1_${data.agentId}`,
        CSS_URL_VARIABLES: data.config.stylesLinks.variables,
    };

    /** use this to create a new element or append it to the body */
    const Bot = {
        /**
         * Create a DOM element with optional properties and children.
         * @param {string} tag - The HTML tag name to create (e.g., 'div', 'button').
         * @param {Object} [props={}] - Properties/attributes to assign directly on the element (e.g., className, innerText, onclick).
         * @param {Array<HTMLElement|string>} [children=[]] - Child nodes or text to append to the created element.
         * @returns {HTMLElement} The created DOM element.
         */
        CreateElement: (tag, props = {}, children = []) => {
            if (props.id) {
                const elem = document.getElementById(props.id);
                if (elem) return elem;
            }
            //validate if exists a tag with this name
            const el = document.createElement(tag);
            Object.assign(el, props);
            // Auto-assign an id based on the provided name prop if present and id not explicitly set
            for (const child of children) {
                if (typeof child === 'string') {
                    el.appendChild(document.createTextNode(child));
                } else if (child) {
                    el.appendChild(child);
                }
            }
            return el;
        },
        /** Append an element to the body */
        /*
         * @param {string} sel
         */
        /**
         * Dynamically load a script into the page.
         * @param {string} src - Absolute or relative URL of the script to load.
         * @returns {Promise<void>} Resolves when the script loads, rejects if it fails.
         */
        loadScript(src) {
            return new Promise((resolve, reject) => {
                const s = document.createElement('script');
                s.src = src;
                s.async = true;
                s.onload = () => resolve();
                s.onerror = () => reject(new Error('Failed to load script: ' + src));
                document.head.appendChild(s);
            });
        },
        /**
         * Shortcut for querySelector with optional root.
         * @param {string} sel - CSS selector to query.
         * @param {ParentNode} [root=document] - Root element to search within.
         * @returns {Element|null} The first matched element or null.
         */
        QSelector: (sel, root = document) => root.querySelector(sel),
        /**
         * Format a string by replacing tokens like {name} with values from params.
         * @param {string} str - String template containing {tokens}.
         * @param {Object.<string, string|number>} [params={}] - Key-value pairs used to replace tokens.
         * @returns {string} The formatted string.
         */
        fmt(str, params = {}) {
            if (!str) return '';
            return String(str).replace(/\{(\w+)}/g, (_, k) => (k in params ? String(params[k]) : '{' + k + '}'));
        },
        /** Preconnect to a domain */
        /**
         * Add a <link rel="preconnect"> for performance.
         * @param {string} href - The origin to preconnect to (e.g., https://fonts.googleapis.com).
         * @param {boolean} [crossing=false] - Whether to set crossOrigin="anonymous".
         */
        preconnect(href, crossing) {
            try {
                const exists = Array.from(document.querySelectorAll('link[rel="preconnect"]')).some(
                    (l) => l.href === href
                );
                if (exists) return;
                const link = document.createElement('link');
                link.rel = 'preconnect';
                link.href = href;
                if (crossing) link.crossOrigin = 'anonymous';
                document.head.appendChild(link);
            } catch {}
        },
        /**
         * Resolve default stylesheet URL for the widget.
         * @returns {string} Absolute URL pointing to styles.css, with fallbacks.
         */
        getDefaultCssUrl() {
            try {
                const s = document.currentScript || Array.from(document.getElementsByTagName('script')).slice(-1)[0];
                if (s && s.src) {
                    return new URL('styles.css', s.src).href;
                }
            } catch {}
            return './styles.css';
        },
        /** Ensure fonts and styles are loaded */
        /**
         * Ensure Google Fonts and widget stylesheet are loaded.
         * Uses preconnect and injects <link> elements once.
         */
        async ensureFontsAndStyles() {
            /** Allow host to override CSS URL via params */
            const cssUrlMain = commonKeys.CSS_URL;
            const cssUrlColors = commonKeys.CSS_URL_VARIABLES;

            /** Inject widget CSS */
            if (!this.cssAlreadyLoaded(cssUrlMain)) {
                await this.loadCSS(cssUrlMain, 'sbx-bot-styles');
            }
            if (cssUrlColors) {
                if (!this.cssAlreadyLoaded(cssUrlColors)) {
                    await this.loadCSS(cssUrlColors, 'sbx-bot-styles-colors');
                }
            }
        },
        cssAlreadyLoaded(url) {
            const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
            return links.some((link) => link.href.includes(url));
        },
        /** Load a CSS file */
        /**
         * Inject a stylesheet link into the document head if not already present.
         * @param {string} href - URL of the CSS file.
         * @param {string} [id] - Optional id attribute to deduplicate by element id.
         */
        async loadCSS(href, id) {
            try {
                await new Promise((resolve) => {
                    if (id && document.getElementById(id)) return;
                    /** Prevent duplicate by href */
                    const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(
                        (l) => l.href === href
                    );
                    if (existing) return;
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = href;
                    if (id) link.id = id;
                    document.head.appendChild(link);
                    link.onload = resolve;
                });
            } catch {}
        },
        /** Ensure audio context is available */
        /**
         * Ensure a Web Audio context is available (if sound is enabled).
         * @returns {AudioContext|null} The shared AudioContext or null when unavailable/disabled.
         */
        ensureAudio() {
            if (!this.isSoundEnabled()) return null;
            try {
                if (!state.audioCtx) {
                    const Ctx = window.AudioContext || window.webkitAudioContext;
                    if (!Ctx) return null;
                    state.audioCtx = new Ctx();
                }
                return state.audioCtx;
            } catch {
                return null;
            }
        },
        /** Check if sounds are enabled */
        /**
         * Check if sound is enabled according to localStorage preference.
         * @returns {boolean} True when sound effects are enabled.
         */
        isSoundEnabled() {
            try {
                const v = localStorage.getItem(commonKeys.SOUND_PREF_KEY);
                return v === null ? true : v === 'true';
            } catch {
                return true;
            }
        },
        /** Encryption helpers for sbx-bot-session */
        /**
         * Build a simple byte key derived from host + agent for XOR obfuscation.
         * @returns {Uint8Array} Key bytes.
         */
        _keyBytes() {
            try {
                const enc = new TextEncoder();
                const material = `${location.host}|${data.agentId}|sbx`;
                return enc.encode(material);
            } catch {
                /** Fallback simple key */
                return new Uint8Array([115, 98, 120, 45, 107, 101, 121]);
            }
        },
        /**
         * XOR two byte arrays with a repeating key.
         * @param {Uint8Array} dataBytes - Input bytes to obfuscate/deobfuscate.
         * @param {Uint8Array} keyBytes - Key bytes used cyclically across data.
         * @returns {Uint8Array} New Uint8Array with XOR-applied bytes.
         */
        _xorBytes(dataBytes, keyBytes) {
            const out = new Uint8Array(dataBytes.length);
            for (let i = 0; i < dataBytes.length; i++) {
                out[i] = dataBytes[i] ^ keyBytes[i % keyBytes.length];
            }
            return out;
        },
        /**
         * Encode a byte array to a base64 string.
         * @param {Uint8Array} bytes - Bytes to encode.
         * @returns {string} Base64 string or empty string on failure.
         */
        _b64encode(bytes) {
            let binary = '';
            for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
            try {
                return btoa(binary);
            } catch {
                return '';
            }
        },
        /**
         * Decode a base64 string into a byte array.
         * @param {string} b64 - Base64 encoded input.
         * @returns {Uint8Array} Decoded bytes or empty array on failure.
         */
        _b64decode(b64) {
            try {
                const bin = atob(b64);
                const out = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
                return out;
            } catch {
                return new Uint8Array(0);
            }
        },
        /**
         * Obfuscate session object using a lightweight XOR + base64 scheme.
         * Fallbacks to plain JSON string on failure.
         * @param {any} obj - Session object to persist.
         * @returns {string} Encoded string representation.
         */
        encryptSession(obj) {
            try {
                const enc = new TextEncoder();
                const plain = enc.encode(JSON.stringify(obj));
                const key = this._keyBytes();
                const x = this._xorBytes(plain, key);
                return 'enc1:' + this._b64encode(x);
            } catch {
                /** Fallback to plain JSON if something goes wrong */
                try {
                    return JSON.stringify(obj);
                } catch {
                    return '';
                }
            }
        },
        /**
         * Decode a session string produced by encryptSession().
         * Supports both enc1: base64-xor format and plain JSON for backward compatibility.
         * @param {string} str - Encoded session string from storage.
         * @returns {object|null} Decoded session object or null on failure.
         */
        decryptSession(str) {
            try {
                if (typeof str !== 'string') return null;
                if (str.startsWith('enc1:')) {
                    const payload = str.slice(5);
                    const bytes = this._b64decode(payload);
                    const key = this._keyBytes();
                    const plainBytes = this._xorBytes(bytes, key);
                    const dec = new TextDecoder();
                    const json = dec.decode(plainBytes);
                    return JSON.parse(json);
                }
                /** Backward compatibility: allow plain JSON */
                return JSON.parse(str);
            } catch (e) {
                return null;
            }
        },
        /** Play a sound */
        /**
         * Play a short notification sound (if AudioContext available and enabled).
         * @returns {Promise<void>} Resolves after scheduling the tone.
         */
        playBotSound: async function () {
            const ctx = this.ensureAudio();
            if (!ctx) return;
            try {
                if (ctx.state === 'suspended') {
                    /** If suspended and no user gesture occurred, this will fail silently; ignore. */
                    await ctx.resume().catch(() => {});
                }
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                /** Pleasant two-tone blip */
                osc.type = 'sine';
                const t0 = ctx.currentTime;
                osc.frequency.setValueAtTime(880, t0);
                osc.frequency.exponentialRampToValueAtTime(1320, t0 + 0.08);
                gain.gain.setValueAtTime(0.0001, t0);
                gain.gain.exponentialRampToValueAtTime(0.06, t0 + 0.02);
                gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.2);
                osc.connect(gain);
                gain.connect(ctx.destination);
                osc.start(t0);
                osc.stop(t0 + 0.22);
            } catch {
                /** Ignore any audio errors */
            }
        },
        /** Emit external integration events (compatible with legacy formatScript botEventService)
         * @param {string} type - Event label (e.g., 'botStarted', 'newMessageReceived', 'chatFinished').
         * @param {any} [info] - Optional payload to include under detail.info.
         */
        sendEvent(type, info) {
            try {
                const event = new CustomEvent('onBotService', {
                    detail: {
                        info: {
                            openCloseChat: (open) => Bot.toggleOpen(typeof open === 'boolean' ? open : undefined),
                            onFinishChat: () => Bot.finalizeChat(),
                            onAssessorRequest: () => {
                                try {
                                    if (state.twilio?.conversation) {
                                        state.twilio.conversation.sendMessage(Bot.t('agent_message_action'));
                                    }
                                } catch {}
                            },
                            ...(info || {}),
                        },
                        type,
                        agentId: data.agentId,
                        session: state.session || null,
                        sessionKey: commonKeys.STORAGE_KEY,
                    },
                });
                window.dispatchEvent(event);
            } catch (e) {
                console.warn('sendEvent dispatch failed', e);
            }
        },
        /** Fetch IP info from ipapi.co */
        /**
         * Fetch geolocation/IP information from configured provider.
         * @returns {Promise<object|null>} Parsed JSON on success or null on failure.
         */
        fetchIpInfo: async function () {
            try {
                const r = await fetch(data.config.locationUrl);
                if (!r.ok) throw new Error('ipapi error');
                return await r.json();
            } catch {
                return null;
            }
        },
        /** Start a remote session */
        /**
         * Start a remote chat session with backend, enriching with IP metadata.
         * @param {{name:string, phone:string, email?:string}} params - Contact info.
         * @param {string} params.name - User name collected in onboarding.
         * @param {string} params.phone - Digits-only local phone input; country code is prepended inside.
         * @param {string} [params.email] - Optional email.
         * @returns {Promise<{data:any, payload:Object}>} Backend response and request payload used.
         */
        startRemoteSession: async function ({ name, phone, email }) {
            /** Build metadata as a sample */
            const ipinfo = await this.fetchIpInfo();
            const metadata = {
                origin: location.origin,
                params: this.getUrlParamsObject(),
                fullUrl: location.href,
                ...(ipinfo || {}),
                ...(state.onboarding.metadata ?? {}),
                extra_metadata: state.onboarding.metadata,
            };
            /** Build a phone to send: country_calling_code (from ipinfo) + digits-only phone */
            const codeDigits = ipinfo?.country_calling_code || '';
            const phoneDigits = String(phone || '').replace(/\D+/g, '');
            const phoneToSend = codeDigits + phoneDigits;
            const payload = {
                name,
                email: email || '',
                phone: phoneToSend,
                agent_id: data.agentId,
                version: 'v2',
                metadata,
            };

            if (this.t('initial_bot_message')) {
                payload.initial_message = this.t('initial_bot_message');
            }
            const res = await fetch(data.config.baseUrl.concat(data.config.sessionPath), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: '*/*' },
                body: JSON.stringify(payload),
            });
            const response = await res.json().catch(() => null);
            if (!res.ok) {
                const err = new Error('Chat API error');
                err.response = response;
                throw err;
            }
            return { data: response, payload };
        },
        /** Get URL params as an object */
        /**
         * Parse current window.location.search into a plain object.
         * @returns {Object.<string,string>} Key/value map of URL query parameters.
         */
        getUrlParamsObject() {
            try {
                const params = new URLSearchParams(location.search || '');
                const obj = {};
                for (const [k, v] of params.entries()) obj[k] = v;
                return obj;
            } catch {
                return {};
            }
        },
        /**
         * Load a previously persisted chat session from localStorage.
         * @returns {object|null} Session object or null if none/invalid.
         */
        loadSession() {
            try {
                const raw = localStorage.getItem(commonKeys.STORAGE_KEY);
                if (!raw) return null;
                const decrypted = Bot.decryptSession(raw);
                if (!decrypted) return null;
                return decrypted;
            } catch {
                return null;
            }
        },
        /** Load Twilio Conversations SDK at once */
        /**
         * Load Twilio Conversations SDK once and memoize its loaded state.
         * @returns {Promise<void>} Resolves when SDK is available or if already loaded.
         */
        async loadTwilioSdkOnce() {
            if (state.twilio.sdkLoaded) return Promise.resolve();
            try {
                await this.loadScript(
                    'https://media.twiliocdn.com/sdk/js/conversations/v2.4/twilio-conversations.min.js'
                );
                state.twilio.sdkLoaded = true;
            } catch (e) {
                console.warn('Twilio SDK failed to load', e);
            }
        },
        /**
         * Render an array of Twilio messages into the transcript.
         * @param {Array<object>} messages - Twilio SDK message items (with state.author, state.body, state.dateUpdated).
         * @returns {Promise<void>}
         */
        async loadMessages(messages) {
            const container = Content.ensureContainer();
            const transcript = container.querySelector('.fbw-transcript');
            const body = container.querySelector('.fbw-body');

            if (messages[0]?.state.body === this.t('initial_message')) {
                messages.shift();
            }

            for (const m of messages) {
                const author = m.state.author;
                switch (true) {
                    case author === state.session?.phone:
                        const msgUser = await this.addMessage('user', m.state.body ?? '', m.state.dateUpdated, m);
                        const bubbleUser = Content.messageBubble(msgUser, null, { animate: true });
                        transcript.appendChild(bubbleUser);
                        break;

                    case state.botName.some((e) => e === author):
                        state.assessorActive = false;
                        const msgBot = await this.addMessage('bot', m.state.body ?? '', m.state.dateUpdated, m);
                        const bubbleBot = Content.messageBubble(msgBot, null, { animate: true });
                        transcript.appendChild(bubbleBot);
                        break;

                    default:
                        state.assessorActive = true;
                        const msgAgent = await this.addMessage('agent', m.state.body ?? '', m.state.dateUpdated, m, {
                            name: author,
                        });
                        const bubbleAgent = Content.messageBubble(msgAgent, null, { animate: true });
                        transcript.appendChild(bubbleAgent);
                        this.hideAssessorBtn();
                        break;
                }
            }
            Bot.scrollToBottom(body);
        },
        hideAssessorBtn() {
            const assessorBtn = Bot.QSelector('#call-assessor-btn');
            if (!assessorBtn.classList.contains('fbw-not-visible')) {
                assessorBtn.classList.add('fbw-not-visible');
            }
        },
        /** Set up Twilio Conversations if the session contains sid and token */
        /**
         * Initialize Twilio Conversations client/conversation if session contains SID and token.
         * Sets up listeners for conversation lifecycle and incoming messages.
         * No-op if data is incomplete or already initialized for the same SID.
         * @returns {Promise<void>}
         */
        async setupTwilioIfAvailable() {
            try {
                const res = state.session?.api?.response || {};
                const sid = res.sid;
                const token = res.token;
                if (!sid || !token) return; /** do nothing without required info */
                /** Avoid re-initialization for the same SID */
                if (state.twilio.conversation && state.twilio.sid === sid) return;
                await Bot.loadTwilioSdkOnce();
                if (!window.Twilio || !window.Twilio.Conversations) return;
                state.twilio.token = token;
                state.twilio.sid = sid;

                state.twilio.client = new window.Twilio.Conversations.Client(token);
                const client = state.twilio.client;
                client.on('conversationRemoved', (c) => {
                    /** Finalize the chat if our active conversation is removed */
                    if (state.twilio.conversation && c.sid === state.twilio.conversation.sid) {
                        Bot.finalizeChat();
                    }
                });

                client.on('conversationJoined', async (c) => {
                    /** Note: may fire for multiple conversations; hold ours */
                    if (c.sid === sid && !state.twilio.conversation) {
                        state.twilio.conversation = c;
                        try {
                            const container = Content.ensureContainer();
                            const toolsEl = container.querySelector('.fbw-tools');
                            if (toolsEl) toolsEl.style.display = '';
                        } finally {
                            await Bot.loadMessages((await c.getMessages()).items);
                        }
                    }
                });

                client.on('tokenAboutToExpire', () => {
                    Bot.finalizeChat();
                });

                client.on('tokenExpired', () => {
                    Bot.finalizeChat();
                });
                /** Fetch conversation and join if needed */
                const conv = await client.getConversationBySid(sid);
                try {
                    await conv.join();
                } catch {
                    /** already joined or not required */
                }
                state.twilio.conversation = conv;
                try {
                    const container = Content.ensureContainer();
                    const toolsEl = container.querySelector('.fbw-tools');
                    if (toolsEl) toolsEl.style.display = '';
                } catch {}
                /** Listen for new messages */
                /*
                 * @Params msg as {author: string, body: string, dateUpdated: string}
                 */
                conv.on('messageAdded', async (msg) => {
                    try {
                        Bot.sendEvent('newMessageReceived', { message: msg });
                    } catch {}

                    try {
                        /** Filter out echoes of our own sent bodies */
                        const container = Content.ensureContainer();
                        const transcript = container.querySelector('.fbw-transcript');
                        const body = container.querySelector('.fbw-body');
                        const typingWrapper = container.querySelector('.fbw-typing');
                        const input = container.querySelector('.fbw-input-message');
                        const sendBtn = container.querySelector('.fbw-btn-send');

                        const bodyMessage = msg?.body ?? '';
                        const author = msg.author ?? 'bot';

                        switch (true) {
                            case author === state.session?.phone:
                                const tempMsgUser = await Bot.addMessage('user', msg.body, null, msg);
                                const bubbleUser = Content.messageBubble(tempMsgUser, null, { animate: true });

                                if (msg.body !== this.t('initial_message')) {
                                    transcript.appendChild(bubbleUser);
                                }
                                input.disabled = false;
                                sendBtn.disabled = false;
                                input?.focus();
                                Bot.scrollToBottom(body);
                                break;

                            case state.botName.some((e) => e === author):
                                if (typingWrapper && typingWrapper.parentNode)
                                    typingWrapper.parentNode.removeChild(typingWrapper);
                                const replyFull = String(bodyMessage || '');
                                const startTs = new Date().toISOString();
                                state.assessorActive = false;
                                const tempMsgBot = await Bot.addMessage('bot', replyFull, startTs, msg);
                                const bubbleBot = Content.messageBubble(tempMsgBot, null, { animate: true });
                                const contentEl = bubbleBot.querySelector('.fbw-msg-text');
                                transcript.appendChild(bubbleBot);
                                Bot.scrollToBottom(body);
                                const words = replyFull.split(' ');
                                let i = 0;
                                const interval = setInterval(() => {
                                    i++;
                                    contentEl.querySelector('.fbw-msg-body').innerHTML = Bot.formatMarkdown(
                                        words.slice(0, i).join(' '),
                                        i < words.length
                                    );
                                    Bot.scrollToBottom(body);
                                    if (i >= words.length) {
                                        clearInterval(interval);

                                        Bot.playBotSound();
                                        input.disabled = false;
                                        sendBtn.disabled = false;
                                        input?.focus();
                                    }
                                }, 20);
                                break;

                            default:
                                if (!state.assessorActive) {
                                    state.assessorActive = true;
                                }
                                const replyFullAgent = String(bodyMessage || '');
                                const startTsAgent = new Date().toISOString();
                                const tempMsgAgent = await Bot.addMessage('agent', replyFullAgent, startTsAgent, msg, {
                                    name: author,
                                });
                                const bubbleAgent = Content.messageBubble(tempMsgAgent, null, { animate: true });
                                transcript.appendChild(bubbleAgent);
                                Bot.QSelector('.fbw-typing')?.remove();
                                input.disabled = false;
                                sendBtn.disabled = false;
                                input?.focus();
                                Bot.hideAssessorBtn();
                                setTimeout(() => Bot.scrollToBottom(body), 100);
                                break;
                        }
                    } catch (e) {
                        console.warn('Failed to append incoming message', e);
                    }
                });
            } catch (e) {
                console.warn('Twilio setup error', e);
            } finally {
                if (containerId) {
                    Bot.toggleOpen(true);
                }
            }
        },
        /** Finalize chat helper (mirrors header menu finalize) */
        /**
         * Clear local message history and session data, reset Twilio references, and re-render widget.
         */
        finalizeChat() {
            try {
                localStorage.removeItem(this.messagesKey());
            } catch {}
            try {
                localStorage.removeItem(commonKeys.STORAGE_KEY);
            } catch {}
            state.session = null;
            state.pendingMessage = null;
            state.assessorActive = false;
            state.sentRoleOptions = new Set();
            state.onboarding = { index: 0, asked: false, name: '', phone: '' };
            /** clear twilio refs */
            state.twilio = {
                sdkLoaded: state.twilio.sdkLoaded,
                client: state.twilio.client,
                conversation: null,
                sid: null,
                token: null,
                pendingUserBodies: [],
            };
            const c = Content.ensureContainer();
            state.open = true;
            if (c) {
                c.classList.remove('fbw-hidden');
                c.classList.add('fbw-open');
            }
            Content.render();
            try {
                const body = (c || document).querySelector('.fbw-body');
                if (body) requestAnimationFrame(() => this.scrollToBottom(body));
            } catch {}
            /** Notify external listeners */
            try {
                this.sendEvent('chatFinished', {});
            } catch {}
        },
        /**
         * Scroll a container to its bottom (smooth when supported).
         * @param {HTMLElement} scroller - The scrollable element.
         */
        scrollToBottom(scroller) {
            if (!scroller) return;
            try {
                scroller.scrollTo({ top: scroller.scrollHeight, behavior: 'smooth' });
            } catch (e) {
                /** Older browsers */
                scroller.scrollTop = scroller.scrollHeight;
            }
        },
        /**
         * Toggle the widget open/closed state.
         * @param {boolean} [force] - If provided, forces the state; otherwise toggles current.
         */
        toggleOpen(force) {
            const container = Content.ensureContainer();
            state.open = typeof force === 'boolean' ? !!force : !state.open;
            if (state.open) {
                container.classList.remove('fbw-hidden');
                container.classList.add('fbw-open');
                /** When opening, ensure the latest message is visible after layout */
                const body = container.querySelector('.fbw-body');
                try {
                    requestAnimationFrame(() => requestAnimationFrame(() => this.scrollToBottom(body)));
                } catch {
                    this.scrollToBottom(body);
                }
                /** If there is a pending quick message and the session already exists, auto-send now */
                if (state.pendingMessage && state.session) {
                    const input = container.querySelector('.fbw-input-message');
                    const form = container.querySelector('.fbw-chat-input');
                    if (input && form) {
                        input.value = state.pendingMessage;
                        state.pendingMessage = null;
                    }
                }
            } else {
                container.classList.add('fbw-hidden');
                container.classList.remove('fbw-open');
            }
            /** Emit open/close event for external listeners */
            try {
                this.sendEvent('openCloseChat', { open: state.open });
            } catch {}
        },
        /**
         * Compare two Date objects by calendar day.
         * @param {Date} a
         * @param {Date} b
         * @returns {boolean} True if same yyyy-mm-dd.
         */
        isSameDay(a, b) {
            return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
        },
        /**
         * Translate a key using provided texts map.
         * @param {string} key - Translation key.
         * @returns {string} Localized string or the key when missing.
         */
        t(key) {
            const txt = data.texts[key] || '';
            return txt.replace(/\{agentName}/, data.agentName);
        },
        /**
         * Format an ISO timestamp into a human-friendly label (Today shows only time).
         * @param {string|number|Date} iso - ISO string or value accepted by Date constructor.
         * @returns {string} Localized short date/time string.
         */
        formatTimestamp(iso) {
            const d = new Date(iso);
            const today = new Date();
            const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            if (isNaN(d.getTime())) return '';
            if (this.isSameDay(d, today)) return time;
            const date = d.toLocaleDateString();
            return `${date} ${time}`;
        },
        /**
         * Normalize a string for loose comparisons (trim + lowercase).
         * @param {string} str
         * @returns {string}
         */
        normalize(str) {
            return String(str || '')
                .trim()
                .toLowerCase();
        },
        /**
         * Attempt to resume a suspended AudioContext (e.g., after user interaction).
         * Safe to call regardless of context state.
         */
        tryResumeAudio() {
            const ctx = this.ensureAudio();
            if (ctx && ctx.state === 'suspended') {
                try {
                    ctx.resume();
                } catch {}
            }
        },
        /**
         * Persist current session to localStorage using encryptSession().
         * @param {object} data - Session object to save.
         */
        saveSession(data) {
            try {
                const enc = Bot.encryptSession(data);
                localStorage.setItem(commonKeys.STORAGE_KEY, enc);
            } catch {}
        },
        /**
         * Build a localStorage key for persisting message history for the active identity.
         * @returns {string} Storage key combining agent prefix and current user identity.
         */
        messagesKey() {
            const id = state.session?.phone || state.session?.name || 'default';
            return `${commonKeys.MESSAGES_PREFIX}:${id}`;
        },
        /**
         * Build a normalized message record and render-ready HTML from text or Twilio media message.
         * @param {'user'|'bot'|'system'|'session'|'agent'} sender - Who sent the message.
         * @param {string} [text] - Optional plain text to render (Markdown supported).
         * @param {string} [ts] - ISO timestamp; defaults to now.
         * @param {object} [message] - Optional Twilio message object (may contain media).
         * @param {{name?: string}} [header] - Optional header data such as agent name.
         * @returns {Promise<{sender:string,text:string,ts:string,header?:object}>} Message model used by UI.
         */
        async addMessage(sender, text, ts, message, header) {
            /** Build a valid HTML snippet for the message content. */
            /** If a Twilio message with media is provided, render an appropriate component (img/audio/pdf/link). */
            function inferExtFromUrl(u) {
                try {
                    const p = new URL(u, location.href);
                    const last = (p.pathname.split('/').pop() || '').toLowerCase();
                    const qname = (p.searchParams.get('filename') || '').toLowerCase();
                    return (qname || last).split('.').pop() || '';
                } catch {
                    return '';
                }
            }

            function safeFileName(u, fallback = 'file') {
                try {
                    const p = new URL(u, location.href);
                    const fromQ = p.searchParams.get('filename');
                    const last = p.pathname.split('/').pop();
                    return fromQ || last || fallback;
                } catch {
                    return fallback;
                }
            }

            function getFileHtml(url) {
                /** Try to read metadata from the Twilio message object; fall back to URL heuristics */
                let contentType = message?.media?.state?.contentType || message?.state?.media?.contentType || '';
                let filename =
                    message?.media?.state?.filename || message?.state?.media?.filename || safeFileName(url, 'file');
                const ext = inferExtFromUrl(url);
                const lc = contentType.toLowerCase();
                const isImage =
                    lc.includes('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext);
                const isAudio = lc.includes('audio/') || ['mp3', 'wav', 'ogg', 'm4a', 'webm'].includes(ext);
                const isPdf = lc.includes('pdf') || ext === 'pdf';
                const isDocLike =
                    lc.includes('spreadsheetml') ||
                    lc.includes('csv') ||
                    lc.includes('wordprocessingml') ||
                    lc.includes('text') ||
                    ['csv', 'xlsx', 'xls', 'doc', 'docx', 'txt', 'rtf'].includes(ext);

                /** Limit label length for display */
                const shortName = String(filename).slice(0, isImage || isPdf ? 20 : 28);

                /** File size helpers */
                const formatBytes = (bytes) => {
                    if (!bytes || isNaN(bytes)) return '';
                    const units = ['B', 'KB', 'MB', 'GB'];
                    const i = Math.floor(Math.log(bytes) / Math.log(1024));
                    const v = bytes / Math.pow(1024, i);
                    return `${v.toFixed(v >= 100 || i === 0 ? 0 : 1)} ${units[i]}`;
                };

                /** Try to get size from Twilio metadata or via HEAD/GET */
                let sizeBytes = message?.media?.state?.size || message?.state?.media?.size || 0;

                /** Choose icon by type */
                const iconPdf = `<?xml version="1.0"?>${`<svg version="1.1" id="_x35_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon style="fill:#B12A27;" points="475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 "></polygon> <rect x="36.565" y="34.295" style="fill:#F2F2F2;" width="205.097" height="91.768"></rect> <g> <g> <path style="fill:#B12A27;" d="M110.132,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.658-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.126-1.432-8.141-1.432H69.651v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.372-2.261,6.031-3.92c1.659-1.658,2.865-3.543,3.769-5.804c0.829-2.186,1.282-4.523,1.282-6.935 C111.413,68.902,110.961,66.565,110.132,64.379z M97.844,77.118c-1.508,1.432-3.618,2.186-6.181,2.186H81.034V63.323h10.629 c2.563,0,4.674,0.754,6.181,2.261c1.432,1.432,2.186,3.392,2.186,5.804C100.031,73.726,99.277,75.686,97.844,77.118z"></path> <path style="fill:#B12A27;" d="M164.558,75.761c-0.075-2.035-0.151-3.844-0.377-5.503c-0.226-1.659-0.603-3.166-1.131-4.598 c-0.528-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.523-5.126-7.312-6.483c-2.865-1.357-6.257-2.035-10.252-2.035h-20.956 v58.195h20.956c3.995,0,7.387-0.678,10.252-2.035c2.789-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.583-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.226-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.151,3.091-0.302,4.297 c-0.151,1.131-0.377,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.669V63.323 h8.669c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186s0.528,1.809,0.678,3.015 c0.151,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z"></path> <path style="fill:#B12A27;" d="M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z"></path> </g> <g> <path style="fill:#B12A27;" d="M110.132,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.658-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.126-1.432-8.141-1.432H69.651v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.372-2.261,6.031-3.92c1.659-1.658,2.865-3.543,3.769-5.804c0.829-2.186,1.282-4.523,1.282-6.935 C111.413,68.902,110.961,66.565,110.132,64.379z M97.844,77.118c-1.508,1.432-3.618,2.186-6.181,2.186H81.034V63.323h10.629 c2.563,0,4.674,0.754,6.181,2.261c1.432,1.432,2.186,3.392,2.186,5.804C100.031,73.726,99.277,75.686,97.844,77.118z"></path> </g> </g> <polygon style="opacity:0.08;fill:#040000;" points="475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.705,219.667 259.54,207.832 266.098,201.273 277.029,190.343 289.995,177.377 412.491,54.881 "></polygon> <polygon style="fill:#771B1B;" points="475.435,117.836 357.599,117.836 357.599,0 "></polygon> <g> <path style="fill:#F2F2F2;" d="M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.544-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.995-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.584-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.829-9.046-2.035-13.117 c-1.809-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.151-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.801,11.76c-6.332,7.538-9.724,17.866-9.875,30.002c-0.226,18.544,1.281,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.87,41.611c-7.086,14.398-14.247,26.836-19.223,35.279 c-3.769,6.408-7.915,13.117-12.212,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.373,7.011-34.902,16.056-46.059,26.836 c-7.237,6.935-12.137,14.323-14.549,22.012c-2.563,7.915-2.412,15.83,0.452,22.916c2.638,6.558,7.387,12.061,13.72,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.101,3.015,15.604,3.015c12.74,0,25.856-5.503,36.937-15.378 c20.655-18.469,41.988-48.169,54.577-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.926-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.629,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.151,0.075 c5.126,3.392,10.026,6.181,14.926,8.443c5.503,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.18,387.694,418.899,378.724,414.376,370.658z M247.705,219.667 c-1.055-9.348-1.508-19.072-1.357-29.324c0.151-9.724,3.694-16.283,8.895-16.283c3.92,0,8.066,3.543,9.95,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.151,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.111,19.75-4.975,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.705,219.667z M121.967,418.073 c-1.282-3.166,0.151-9.272,7.991-16.81c11.986-11.458,30.756-20.504,56.914-27.364c-4.975,6.784-9.875,12.966-14.624,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.352,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.168,423.049,123.173,421.089,121.967,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.151-0.377,0.377-0.754,0.603-1.055c3.166-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.734,2.035,3.543,3.995,5.352,5.955l-1.206,0.075l1.055,0.98 c-3.091,0.226-6.332,0.528-9.574,0.829c-2.035,0.226-4.146,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.297,384.98c-8.971-5.729-18.996-13.795-31.359-24.575c17.564,1.809,31.359,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.618,3.844,4.9,7.312,4.221,9.649c-0.603,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.88-1.432c-3.468-1.658-7.086-3.694-10.93-6.181C369.598,385.282,369.448,385.131,369.297,384.98z"></path> </g> </g> </g></svg>`}`;
                const iconExcel = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>file_type_excel2</title><path d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z" style="fill:#20744a;fill-rule:evenodd"></path><rect x="22.487" y="7.439" width="4.323" height="2.2" style="fill:#20744a"></rect><rect x="22.487" y="10.94" width="4.323" height="2.2" style="fill:#20744a"></rect><rect x="22.487" y="14.441" width="4.323" height="2.2" style="fill:#20744a"></rect><rect x="22.487" y="17.942" width="4.323" height="2.2" style="fill:#20744a"></rect><rect x="22.487" y="21.443" width="4.323" height="2.2" style="fill:#20744a"></rect><polygon points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673" style="fill:#ffffff;fill-rule:evenodd"></polygon></g></svg>`;
                const iconWord = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>file_type_word2</title><path d="M18.536,2.323V4.868c3.4.019,7.12-.035,10.521.019a.783.783,0,0,1,.912.861c.054,6.266-.013,12.89.032,19.157-.02.4.009,1.118-.053,1.517-.079.509-.306.607-.817.676-.286.039-.764.034-1.045.047-2.792-.014-5.582-.011-8.374-.01l-1.175,0v2.547L2,27.133Q2,16,2,4.873L18.536,2.322" style="fill:#283c82"></path><path d="M18.536,5.822h10.5V26.18h-10.5V23.635h8.27V22.363h-8.27v-1.59h8.27V19.5h-8.27v-1.59h8.27V16.637h-8.27v-1.59h8.27V13.774h-8.27v-1.59h8.27V10.911h-8.27V9.321h8.27V8.048h-8.27V5.822" style="fill:#fff"></path><path d="M8.573,11.443c.6-.035,1.209-.06,1.813-.092.423,2.147.856,4.291,1.314,6.429.359-2.208.757-4.409,1.142-6.613.636-.022,1.272-.057,1.905-.1-.719,3.082-1.349,6.19-2.134,9.254-.531.277-1.326-.013-1.956.032-.423-2.106-.916-4.2-1.295-6.314C8.99,16.1,8.506,18.133,8.08,20.175q-.916-.048-1.839-.111c-.528-2.8-1.148-5.579-1.641-8.385.544-.025,1.091-.048,1.635-.067.328,2.026.7,4.043.986,6.072.448-2.08.907-4.161,1.352-6.241" style="fill:#fff"></path></g></svg>`;
                const iconText = `<svg  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path style="fill:#DBE9FD;" d="M389.662,66.461H122.338c-27.639,0-50.123,22.484-50.123,50.123v345.293 c0,27.639,22.484,50.123,50.123,50.123h267.323c27.639,0,50.123-22.484,50.123-50.123V116.584 C439.785,88.945,417.301,66.461,389.662,66.461z"></path> <path style="fill:#C5DCFD;" d="M389.662,66.461H256V512h133.662c27.639,0,50.123-22.484,50.123-50.123V116.584 C439.785,88.945,417.301,66.461,389.662,66.461z"></path> <path style="fill:#6BBAE2;" d="M289.416,244.677h-66.831c-9.224,0-16.708-7.478-16.708-16.708v-61.262h-50.123 c-6.331,0-12.118-3.573-14.946-9.235c-2.828-5.662-2.219-12.433,1.577-17.496L242.632,6.315c6.309-8.42,20.428-8.42,26.737,0 l100.246,133.662c3.796,5.064,4.405,11.835,1.577,17.496c-2.828,5.662-8.615,9.235-14.946,9.235h-50.123v61.262 C306.123,237.199,298.639,244.677,289.416,244.677z"></path> <path style="fill:#8A9199;" d="M356.246,311.508h-27.128c-9.224,0-16.708-7.478-16.708-16.708c0-9.229,7.484-16.708,16.708-16.708 h27.128c9.224,0,16.708,7.478,16.708,16.708C372.954,304.029,365.47,311.508,356.246,311.508z"></path> <g> <path style="fill:#A1AAB3;" d="M262.288,311.508H155.754c-9.224,0-16.708-7.478-16.708-16.708c0-9.229,7.484-16.708,16.708-16.708 h106.534c9.224,0,16.708,7.478,16.708,16.708C278.996,304.029,271.512,311.508,262.288,311.508z"></path> <path style="fill:#A1AAB3;" d="M356.246,378.339H155.754c-9.224,0-16.708-7.478-16.708-16.708c0-9.229,7.484-16.708,16.708-16.708 h200.493c9.224,0,16.708,7.478,16.708,16.708C372.954,370.86,365.47,378.339,356.246,378.339z"></path> <path style="fill:#A1AAB3;" d="M356.246,445.169H155.754c-9.224,0-16.708-7.478-16.708-16.708c0-9.229,7.484-16.708,16.708-16.708 h200.493c9.224,0,16.708,7.478,16.708,16.708C372.954,437.691,365.47,445.169,356.246,445.169z"></path> </g> <g> <path style="fill:#8A9199;" d="M356.246,411.754H256v33.415h100.246c9.224,0,16.708-7.478,16.708-16.708 C372.954,419.232,365.47,411.754,356.246,411.754z"></path> <path style="fill:#8A9199;" d="M356.246,344.923H256v33.415h100.246c9.224,0,16.708-7.478,16.708-16.708 C372.954,352.402,365.47,344.923,356.246,344.923z"></path> </g> <path style="fill:#A9B0B7;" d="M262.288,278.092H256v33.415h6.288c9.224,0,16.708-7.478,16.708-16.708 C278.996,285.571,271.512,278.092,262.288,278.092z"></path> <path style="fill:#60AED5;" d="M289.416,244.677c9.224,0,16.708-7.478,16.708-16.708v-61.262h50.123 c6.331,0,12.118-3.573,14.946-9.235c2.828-5.662,2.219-12.433-1.577-17.496L269.369,6.315C266.214,2.105,261.107,0,256,0v244.677 H289.416z"></path> </g></svg>`;
                const iconCsv = `<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 303.188 303.188\" xml:space=\"preserve\" fill=\"#000000\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <g> <polygon style=\"fill:#E4E4E4;\" points=\"219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 \"></polygon> <polygon style=\"fill:#007934;\" points=\"227.64,25.263 32.842,25.263 32.842,0 219.821,0 \"></polygon> <g> <g> <path style=\"fill:#A4A9AD;\" d=\"M114.872,227.984c-2.982,0-5.311,1.223-6.982,3.666c-1.671,2.444-2.507,5.814-2.507,10.109 c0,8.929,3.396,13.393,10.188,13.393c2.052,0,4.041-0.285,5.967-0.856c1.925-0.571,3.86-1.259,5.808-2.063v10.601 c-3.872,1.713-8.252,2.57-13.14,2.57c-7.004,0-12.373-2.031-16.107-6.094c-3.734-4.062-5.602-9.934-5.602-17.615 c0-4.803,0.904-9.023,2.714-12.663c1.809-3.64,4.411-6.438,7.808-8.395c3.396-1.957,7.39-2.937,11.98-2.937 c5.016,0,9.808,1.09,14.378,3.27l-3.841,9.871c-1.713-0.805-3.428-1.481-5.141-2.031 C118.681,228.26,116.841,227.984,114.872,227.984z\"></path> <path style=\"fill:#A4A9AD;\" d=\"M166.732,250.678c0,2.878-0.729,5.433-2.191,7.665c-1.459,2.232-3.565,3.967-6.315,5.205 c-2.751,1.237-5.977,1.856-9.681,1.856c-3.089,0-5.681-0.217-7.775-0.65c-2.095-0.434-4.274-1.191-6.538-2.27v-11.172 c2.391,1.227,4.877,2.186,7.458,2.872c2.582,0.689,4.951,1.032,7.109,1.032c1.862,0,3.227-0.322,4.095-0.969 c0.867-0.645,1.302-1.476,1.302-2.491c0-0.635-0.175-1.19-0.524-1.666c-0.349-0.477-0.91-0.958-1.682-1.444 c-0.772-0.486-2.83-1.48-6.173-2.983c-3.026-1.375-5.296-2.708-6.809-3.999s-2.634-2.771-3.364-4.443s-1.095-3.65-1.095-5.936 c0-4.273,1.555-7.605,4.666-9.997c3.109-2.391,7.384-3.587,12.822-3.587c4.803,0,9.7,1.111,14.694,3.333l-3.841,9.681 c-4.337-1.989-8.082-2.984-11.234-2.984c-1.63,0-2.814,0.286-3.555,0.857s-1.111,1.28-1.111,2.127 c0,0.91,0.471,1.725,1.412,2.443c0.941,0.72,3.496,2.031,7.665,3.936c3.999,1.799,6.776,3.729,8.331,5.792 C165.955,244.949,166.732,247.547,166.732,250.678z\"></path> <path style=\"fill:#A4A9AD;\" d=\"M199.964,218.368h14.027l-15.202,46.401H184.03l-15.139-46.401h14.092l6.316,23.519 c1.312,5.227,2.031,8.865,2.158,10.918c0.148-1.481,0.443-3.333,0.889-5.555c0.443-2.222,0.835-3.967,1.174-5.236 L199.964,218.368z\"></path> </g> </g> <polygon style=\"fill:#D1D3D3;\" points=\"219.821,50.525 270.346,50.525 219.821,0 \"></polygon> <g> <rect x=\"134.957\" y=\"80.344\" style=\"fill:#007934;\" width=\"33.274\" height=\"15.418\"></rect> <rect x=\"175.602\" y=\"80.344\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.418\"></rect> <rect x=\"134.957\" y=\"102.661\" style=\"fill:#007934;\" width=\"33.274\" height=\"15.419\"></rect> <rect x=\"175.602\" y=\"102.661\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.419\"></rect> <rect x=\"134.957\" y=\"124.979\" style=\"fill:#007934;\" width=\"33.274\" height=\"15.418\"></rect> <rect x=\"175.602\" y=\"124.979\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.418\"></rect> <rect x=\"94.312\" y=\"124.979\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.418\"></rect> <rect x=\"134.957\" y=\"147.298\" style=\"fill:#007934;\" width=\"33.274\" height=\"15.418\"></rect> <rect x=\"175.602\" y=\"147.298\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.418\"></rect> <rect x=\"94.312\" y=\"147.298\" style=\"fill:#007934;\" width=\"33.273\" height=\"15.418\"></rect> <g> <path style=\"fill:#007934;\" d=\"M127.088,116.162h-10.04l-6.262-10.041l-6.196,10.041h-9.821l10.656-16.435L95.406,84.04h9.624 l5.8,9.932l5.581-9.932h9.909l-10.173,16.369L127.088,116.162z\"></path> </g> </g> </g> </g></svg>`;
                const iconOther = `<svg viewBox=\"0 0 1024 1024\" class=\"icon\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"#000000\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M576 102.4H268.8c-14.08 0-25.6 11.52-25.6 25.6v742.4c0 14.08 11.52 25.6 25.6 25.6h512c14.08 0 25.6-11.52 25.6-25.6V332.8L576 102.4z\" fill=\"#00B2AE\"></path><path d=\"M780.8 908.8H268.8c-21.76 0-38.4-16.64-38.4-38.4V128c0-21.76 16.64-38.4 38.4-38.4h312.32L819.2 327.68V870.4c0 21.76-16.64 38.4-38.4 38.4zM268.8 115.2c-7.68 0-12.8 5.12-12.8 12.8v742.4c0 7.68 5.12 12.8 12.8 12.8h512c7.68 0 12.8-5.12 12.8-12.8V337.92L570.88 115.2H268.8z\" fill=\"#231C1C\"></path><path d=\"M576 307.2c0 14.08 11.52 25.6 25.6 25.6h204.8L576 102.4v204.8z\" fill=\"#008181\"></path><path d=\"M806.4 345.6H601.6c-21.76 0-38.4-16.64-38.4-38.4V102.4c0-5.12 2.56-10.24 7.68-11.52 5.12-2.56 10.24-1.28 14.08 2.56l230.4 230.4c3.84 3.84 5.12 8.96 2.56 14.08-1.28 5.12-6.4 7.68-11.52 7.68zM588.8 133.12V307.2c0 7.68 5.12 12.8 12.8 12.8h174.08L588.8 133.12zM332.8 435.2h371.2v25.6H332.8zM332.8 524.8h371.2v25.6H332.8z\" fill=\"#231C1C\"></path><path d=\"M332.8 614.4h371.2v25.6H332.8z\" fill=\"#231C1C\"></path><path d=\"M332.8 716.8h371.2v25.6H332.8z\" fill=\"#231C1C\"></path></g></svg>`;

                let mediaIconDynamicSvg = iconOther;
                const extLower = (ext || '').toLowerCase();
                if (isPdf || extLower === 'pdf' || lc.includes('pdf')) mediaIconDynamicSvg = iconPdf;
                else if (['xls', 'xlsx'].includes(extLower) || lc.includes('excel') || lc.includes('spreadsheetml'))
                    mediaIconDynamicSvg = iconExcel;
                else if (['doc', 'docx'].includes(extLower) || lc.includes('wordprocessingml') || lc.includes('msword'))
                    mediaIconDynamicSvg = iconWord;
                else if (extLower === 'csv' || lc.includes('csv')) mediaIconDynamicSvg = iconCsv;
                else if (lc.startsWith('text/') || ['txt', 'rtf'].includes(extLower)) mediaIconDynamicSvg = iconText;

                /** async size fetch fallback (best-effort) */
                const tryGetSize = async () => {
                    if (sizeBytes) return sizeBytes;
                    try {
                        const head = await fetch(url, { method: 'HEAD' });
                        const len = head.headers.get('content-length');
                        if (len) return parseInt(len, 10);
                    } catch {}
                    try {
                        const resp = await fetch(url);
                        const blob = await resp.blob();
                        return blob.size || 0;
                    } catch {}
                    return 0;
                };

                /** Synchronous label placeholder; will be updated asynchronously if needed */
                let sizeLabel = sizeBytes ? ` (${formatBytes(sizeBytes)})` : '';
                (async () => {
                    if (!sizeBytes) {
                        const b = await tryGetSize();
                        if (b) {
                            /** Update the rendered size in place if present */
                        }
                    }
                })();

                if (isImage) {
                    return `<div class="fbw-file-img"><a href="${url}" target="_blank" rel="noopener"><img src="${url}" alt="${shortName}" style="max-width:240px; height:auto; border-radius:8px; display:block"/></a><div style="margin-top:6px; display:flex; align-items:center; gap:6px; color: white;"><a href="${url}" target="_blank" rel="noopener">${shortName.split(/_/).join(' ')}</a><span style="opacity:.8; font-size:10px;">${sizeLabel}</span></div></div>`;
                }
                if (isAudio) {
                    return `<div class="fbw-file-audio"><audio controls src="${url}" style="max-width:260px"></audio></div>`;
                }
                if (isPdf) {
                    return `<div class="fbw-file-pdf"><iframe src="${url}" title="${shortName}" style="width:260px;  height:200px; border:none; border-radius:10px; background:#fff"></iframe><div style="margin-top:6px; display:flex; align-items:center; gap:6px; color: white;"><span style="width:18px;height:18px;display:inline-block;">${mediaIconDynamicSvg}</span><a href="${url}" target="_blank" rel="noopener">${shortName.split(/_/).join(' ')}</a><br><span style="opacity:.8; font-size:10px;">${sizeLabel}</span></div></div>`;
                }
                if (isDocLike) {
                    return `<div class="fbw-file-doc" style="display:flex;flex-wrap: wrap; align-items:center;gap:6px; color: white;"><span style="width:18px;height:18px;display:inline-block;">${mediaIconDynamicSvg}</span><a href="${url}" target="_blank" rel="noopener">${shortName.split(/_/).join(' ')}</a><span style="opacity:.8; font-size:10px;">${sizeLabel}</span></div>`;
                }
                /** Fallback generic link */
                return `<div class="fbw-file" style="display:flex;align-items:center;gap:6px; color: white;"><span style="width:18px;height:18px;display:inline-block;">${mediaIconDynamicSvg}</span><a href="${url}" target="_blank" rel="noopener">${shortName.split(/_/).join(' ')}</a><span style="opacity:.8; font-size:10px;">${sizeLabel}</span></div>`;
            }

            const html = await (async () => {
                /** Twilio SDK v2 messages may expose type or require checking media via helpers */
                if (message && typeof message === 'object') {
                    /** If it's a media message, generate a temporary URL and return an appropriate component */
                    try {
                        /** Heuristic: A Twilio SDK message with media exposes getMediaByCategory */
                        if (typeof message.getMediaByCategory === 'function') {
                            const url = await Bot.generateURL(message);
                            if (url) return getFileHtml(url);
                        }
                    } catch {}
                    /** If a plain text body exists, format as Markdown */
                    if (typeof message.body === 'string' && message.body.length) {
                        return Bot.formatMarkdown(message.body);
                    }
                }
                /** Fallbacks: use provided text (format markdown), otherwise empty */
                if (typeof text === 'string') return Bot.formatMarkdown(text);
                return '';
            })();

            return { sender, text: html, ts: ts || new Date().toISOString(), header };
        },
        /**
         * Convert a lightweight Markdown subset to HTML with basic sanitization.
         * Supports bold, italic, strikethrough, inline code, links, headings, and line breaks.
         * NOTE: This is a simple formatter, not a full Markdown parser.
         * @param {string} text - Raw text possibly containing Markdown.
         * @param {boolean} writing - Whether to allow links in the output.
         * @returns {string} HTML string safe to inject (basic entities escaped first).
         */
        formatMarkdown(text, writing = false) {
            if (!text) return '';

            /** Sanitize HTML entities */
            text = text.replace(
                /[&<>"']/g,
                (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&39;' })[m]
            );

            /** **bold** o __bold__ */
            text = text.replace(/(\*\*|__)(.*?)\1/g, '<b>$2</b>');
            /** *italic* o _italic_ */
            text = text.replace(/(\*|_)(.*?)\1/g, (m) => (m.includes('href=') ? m : '<i>$2</i>'));
            /** ~~tachado~~ */
            text = text.replace(/~~(.*?)~~/g, '<s>$1</s>');
            /** code */
            text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
            /** [text](url) */
            text = text.replace(
                /\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/g,
                '<a class="fbw-bot-response-link" href="$2" target="_blank">$1</a>'
            );

            /** validate titles */
            text = text.replace(/#(.*)\n/g, (match) => {
                const level = match.split('#').length;
                return `<h${level}>${match.replaceAll('#', '')}</h${level}>`;
            });

            /** break line -> <br> */
            text = text.replace(/\n/g, '<br>').replace(/&39;|&quot;/g, (m) => ({ '&39;': "'", '&quot;': '"' })[m]);

            /** images link*/
            text = text.replace(/&lt;|&gt;/g, (m) => {
                return {
                    '&lt;': '<',
                    '&gt;': '>',
                }[m];
            });
            if (writing) {
                const pair = text.length % 2 === 0;
                text = text.replace(
                    /<img.*?>/g,
                    `<div class="fbw-preload-image fbw-rotate-${pair === 0 ? '180' : '360'}">${pair ? '..' : '...'}</div>`
                );
            } else {
                text = text.replace(
                    /<img.*?src="(.*?)".*?alt="(.*?)".*?> /g,
                    `<a href="$1" target="_blank"><img src="$1" alt="$2" class="fbw-img-text-rendered"/></a>`
                );
            }
            return text || '';
        },
        /** Send media/audio or text via Twilio using prepareMessage + addMedia when a file is present */
        /**
         * Send a text message or upload media/attachments via Twilio Conversations.
         * Shows a temporary typing indicator while sending.
         * @param {{message?:string, file?:File|null, kind?:'audio'|'file'|''}} [options]
         * @param {string} [options.message] - Text body to send when no file is provided.
         * @param {File|null} [options.file] - File or audio blob to send.
         * @param {'audio'|'file'|''} [options.kind] - Sending mode; 'audio' to send recorded audio, 'file' for attachments.
         * @returns {Promise<void>}
         */
        async sendMediaOrAttachment({ message = '', file = null, kind = '' } = {}) {
            const conversation = state.twilio?.conversation;
            if (!conversation) throw new Error('No active Twilio conversation');

            /** UI: show a temporary typing/loading indicator */
            if (!state.assessorActive) {
                Bot.loadingMessage();
            }

            try {
                const isMedia = kind === 'audio';
                const isAttachment = kind === 'file';

                switch (true) {
                    case isMedia && !!file: {
                        const response = await fetch(URL.createObjectURL(file));
                        const fileBlob = await response.blob();

                        const mediaFormData = new FormData();
                        mediaFormData.set('twilio-audio', fileBlob, 'twilio-audio.mp3');

                        const sendMediaOptions = {
                            contentType: response.headers.get('Content-Type'),
                            filename: 'twilio-audio',
                            media: fileBlob,
                        };

                        await conversation
                            .prepareMessage()
                            .setBody('audio!')
                            .addMedia(mediaFormData)
                            .addMedia(sendMediaOptions)
                            .build()
                            .send();
                        break;
                    }
                    case isAttachment && !!file: {
                        const responseImage = await fetch(URL.createObjectURL(file));
                        const fileBlobImage = await responseImage.blob();

                        const attachmentFormData = new FormData();
                        /** filename property fallback for older browsers */
                        const fname = file.name || file.filename || 'file';
                        attachmentFormData.set(`twilio-file`, file, fname);

                        const sendAttachmentOptions = {
                            contentType: responseImage.headers.get('Content-Type'),
                            filename: fname,
                            media: fileBlobImage,
                        };

                        await conversation
                            .prepareMessage()
                            .setBody('attachment!')
                            .addMedia(attachmentFormData)
                            .addMedia(sendAttachmentOptions)
                            .build()
                            .send();
                        break;
                    }
                    default: {
                        await conversation.sendMessage(message || '');
                        break;
                    }
                }
            } catch (err) {
                console.warn('Failed to send via Twilio', err);
            } finally {
                Bot.QSelector('.fbw-typing')?.remove();
            }
        },

        /**
         * Generate a temporary content URL for the first media item in a Twilio message.
         * @param {object} state - Twilio message (or media state) exposing getMediaByCategory().
         * @returns {Promise<string>} A temporary URL to access the media content.
         */
        async generateURL(state) {
            const categorizedMedia = await state.getMediaByCategory(['media']);
            return await categorizedMedia[0].getContentTemporaryUrl();
        },

        /**
         * Capitalize the first character of a string.
         * @param {string} string - Input string.
         * @returns {string} String with the first character uppercased.
         */
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        /**
         * Show the typing/loading message bubble in the transcript (centralized helper).
         * Respects assessorActive flag (does nothing when assessor is active).
         */
        loadingMessage() {
            try {
                if (state.assessorActive) return;
                const container = Content.ensureContainer();
                const transcr = container.querySelector('.fbw-transcript');
                const body = container.querySelector('.fbw-body');
                const typingWrapper = Bot.CreateElement('div', {
                    className: 'fbw-msg fbw-msg-bot fbw-msg-appear from-left fbw-typing',
                    innerHTML:
                        '<div class="fbw-msg-text"><span class="fbw-typing"><span class="dot"></span><span class="dot"></span><span class="dot"></span></span></div>',
                });
                transcr.appendChild(typingWrapper);
                Bot.scrollToBottom(body);
            } catch {}
        },
        /** remove event if exist and create event */
        on(elm, eventName, callback) {
            // Avoid duplicate listeners by removing the same callback before adding.
            try {
                elm.removeEventListener(eventName, callback);
            } catch {}
            elm.addEventListener(eventName, callback);
        },
        /**
         * Remove inline roles markers from a text to avoid showing them in the bubble.
         * Strips HTML comments <!-- roles:[...] --> and lines like "Role: ...".
         * @param {string} s
         * @returns {string}
         */
        stripRolesMarkers(s) {
            try {
                let out = String(s || '');
                // Remove HTML comment marker
                out = out.replace(/<!--\s*roles\s*:\s*\[[\s\S]*?\]\s*-->/gi, '');
                // Remove Role: lines entirely
                out = out
                    .split(/\n|<br\s*\/?>/i)
                    .filter((line) => !/^\s*(?:role|rol|option)\s*[:\-]\s*/i.test(line))
                    .join('\n');
                return out;
            } catch {
                return String(s || '');
            }
        },
        /**
         * Extract role options from a message body text.
         * Supports JSON array markers in text like <!--roles:["a","b"]-->,
         * or lines prefixed by Role: value. Falls back to data.roles_options.
         * @param {string} text
         * @returns {string[]}
         */
        extractRolesFromText(text) {
            try {
                const roles = [];
                const s = String(text || '');
                // Look for HTML comment marker with JSON
                const m = s.match(/<!--\s*roles\s*:\s*(\[[\s\S]*?\])\s*-->/i);
                if (m) {
                    try {
                        const arr = JSON.parse(m[1]);
                        if (Array.isArray(arr)) {
                            arr.forEach((v) => {
                                const t = String(v || '').trim();
                                if (t) roles.push(t);
                            });
                        }
                    } catch {}
                }
                // Also parse lines like "Role: X"
                s.split(/\n|<br\s*\/?>/i).forEach((line) => {
                    const mm = String(line).match(/^\s*(?:role|rol|option)\s*[:\-]\s*(.+)$/i);
                    if (mm && mm[1]) {
                        const t = mm[1].trim();
                        if (t) roles.push(t);
                    }
                });
                // Fallback to configured roles if none found in text
                const cfg = Array.isArray(data.roles_options) ? data.roles_options : [];
                if (roles.length === 0 && cfg.length) return cfg.map((x) => String(x));
                // Deduplicate preserving order
                const seen = new Set();
                const out = [];
                for (const r of roles) {
                    const k = String(r).trim();
                    if (!k || seen.has(k)) continue;
                    seen.add(k);
                    out.push(k);
                }
                return out;
            } catch {
                return Array.isArray(data.roles_options) ? data.roles_options.map(String) : [];
            }
        },
        /**
         * Build an inline roles panel with buttons under a message.
         * @param {string[]} roles
         * @returns {HTMLElement|null}
         */
        buildInlineRolesPanel(roles) {
            try {
                if (!roles || roles.length === 0) return null;
                const panel = Bot.CreateElement('div', { className: 'fbw-roles-inline' });
                const msg = Bot.CreateElement('div', {
                    className: 'fbw-roles-message',
                    innerText: data.role_message || '',
                });
                const buttons = Bot.CreateElement('div', { className: 'fbw-roles-buttons' });
                const onPick = (txt) => {
                    try {
                        data.withInitialMessage = true;
                        Bot.toggleOpen(true);
                    } catch {}
                    const container = document.getElementById(commonKeys.WIDGET_ID);
                    if (state.session && state.twilio?.conversation) {
                        const input = container?.querySelector('.fbw-input-message');
                        const form = container?.querySelector('.fbw-chat-input');
                        if (input) input.value = txt;
                        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                    } else {
                        if (data && data.texts) data.texts.initial_message = txt;
                        state.pendingMessage = txt;
                    }
                    // Collapse inline panel after picking
                    try {
                        panel.classList.add('fbw-hidden');
                    } catch {}
                };
                roles.forEach((role) => {
                    const btn = Bot.CreateElement('button', {
                        className: 'fbw-role-btn',
                        type: 'button',
                        innerText: String(role),
                    });
                    btn.addEventListener('click', () => onPick(String(role)));
                    buttons.appendChild(btn);
                });
                panel.appendChild(msg);
                panel.appendChild(buttons);
                return panel;
            } catch {
                return null;
            }
        },
    };

    const state = {
        sentRoleOptions: new Set(),
        audioCtx: null,
        session: null,
        assessorActive: false,
        open: false,
        botName: ['VirtualAgent', 'botv2', data.identify, data.agentName],
        pendingMessage: false,
        twilio: { sdkLoaded: false, client: null, conversation: null, sid: null, token: null, pendingUserBodies: [] },
        onboarding: { index: 0, asked: false, name: '', phone: '', metadata: {} },
        questions_session: [
            {
                question: Bot.t('q1_question'),
                panel_description: Bot.t('q1_panel_description'),
                step: 1,
                minLength: 4,
                maxLength: 20,
                required: true,
                type: 'text',
                name: 'name',
                regex: /^[A-Za-z ]/,
                error_message: Bot.t('q1_error_message'),
                placeholder: Bot.t('q1_placeholder'),
            },
            {
                question: Bot.t('q2_question'),
                panel_description: Bot.t('q2_panel_description'),
                step: 2,
                required: true,
                regex: /^\(\d{3}\)-\d{3}-\d{4}/,
                type: 'text',
                error_message: Bot.t('q2_error_message'),
                name: 'phone',
                placeholder: Bot.t('q2_placeholder'),
                id: 'phone',
            },
            {
                question: Bot.t('q3_question'),
                panel_description: Bot.t('q3_panel_description'),
                step: 3,
                required: true,
                type: 'terms',
                name: 'terms',
            },
        ],
    };

    /** All elements are created here */
    const Content = {
        /**
         * Build a message header with avatar and display name.
         * @param {string} [name] - Optional explicit name to display (e.g., agent name). Falls back to data.agentName.
         * @returns {HTMLElement} A DOM node containing avatar SVG and name.
         */
        setHeaderAvatar(name) {
            const head = Bot.CreateElement('div', { className: 'fbw-msg-head' });
            /** Inline SVG avatar per requirement */
            const svgWrap = document.createElement('div');
            svgWrap.innerHTML = data.assets.svg.botHeaderMessageIcon;
            const svgEl = svgWrap.firstElementChild;
            if (svgEl) svgEl.classList.add('fbw-msg-avatar');
            head.appendChild(svgEl || svgWrap);
            const nameEl = Bot.CreateElement('span', {
                className: 'fbw-msg-name',
                innerText: Bot.capitalize((name ?? data.agentName).split('@').shift() ?? ''),
            });
            head.appendChild(nameEl);
            return head;
        },
        /**
         * Create a chat message bubble element.
         * Accepts either a message model object ({sender, text, ts, header}) or (sender, text) signature.
         * @param {{sender:string, text:string, ts?:string, header?:{name?:string}}|string} arg1 - Message model or sender.
         * @param {string} [arg2] - Message text when using (sender, text) signature.
         * @param {{animate?:boolean}} [options] - UI options.
         * @returns {HTMLElement} Wrapper element containing message body and meta.
         */
        messageBubble(arg1, arg2, options) {
            /** helper to append inline roles panel after bubble if applicable */
            function maybeAppendRoles(wrapperEl, msgModel) {
                try {
                    if (!wrapperEl || !msgModel) return;
                    // Only for bot messages
                    if (msgModel.sender !== 'bot') return;
                    // Do not show when the assessor (agent) is speaking
                    if (state.assessorActive) return;
                    // Extract roles from the message text or fallback
                    const roles = Bot.extractRolesFromText(msgModel.text);
                    if (!roles || roles.length === 0) return;
                    // Filter out roles already sent
                    const unique = roles.filter((r) => {
                        const k = String(r).trim();
                        if (!k) return false;
                        if (state.sentRoleOptions.has(k)) return false;
                        if (state.session) {
                            state.sentRoleOptions.add(k);
                        }
                        return true;
                    });
                    if (unique.length === 0) return;

                    const panel = Bot.buildInlineRolesPanel(unique);

                    if (panel && state.session) {
                        wrapperEl.appendChild(panel);
                    }
                } catch {}
            }
            /** Support both signatures:
             - messageBubble({ sender, text, ts }, null, { animate })
             - messageBubble(sender, text) */
            let msg;
            if (typeof arg1 === 'object' && arg1 !== null) {
                msg = {
                    sender: arg1.sender || 'bot',
                    text: arg1.text || '',
                    ts: arg1.ts || new Date().toISOString(),
                };
            } else {
                msg = { sender: String(arg1), text: String(arg2 ?? ''), ts: new Date().toISOString() };
            }
            const cls =
                msg.sender === 'user' ? 'fbw-msg-user' : msg.sender === 'system' ? 'fbw-msg-system' : 'fbw-msg-bot';
            const appearDir = msg.sender === 'user' ? 'from-right' : 'from-left';
            const wrapper = Bot.CreateElement('div', {
                className: `fbw-msg ${cls} ${options?.animate ? 'fbw-msg-appear ' + appearDir : ''}`,
                title: new Date(msg.ts).toLocaleString(),
            });

            const box = Bot.CreateElement('div', { className: 'fbw-msg-text' });

            const bodyEl = Bot.CreateElement('div', { className: 'fbw-msg-body' });
            bodyEl.innerHTML = msg.text.replace(/\{name}/g, state.onboarding?.name ?? '{name}');
            if (cls === 'fbw-msg-bot') box.appendChild(Content.setHeaderAvatar(arg1?.header?.name));

            box.appendChild(bodyEl);

            wrapper.appendChild(box);

            /** Timestamp/meta */
            const meta = Bot.CreateElement('div', {
                className: 'fbw-msg-meta',
                innerText: Bot.formatTimestamp(msg.ts),
            });
            wrapper.appendChild(meta);

            // Append inline roles panel (if any)
            try {
                let model =
                    typeof arg1 === 'object' && arg1 !== null
                        ? arg1
                        : { sender: String(arg1), text: String(arg2 ?? '') };

                maybeAppendRoles(box, model);
            } catch {}

            return wrapper;
        },
        /**
         * Ensure the chat widget container exists in the DOM and wire core UI structure/events.
         * Creates toggle button, header, body, footer, and powered-by area when missing.
         * @returns {HTMLElement} Root container element for the widget.
         */
        ensureContainer() {
            let container = document.getElementById(commonKeys.WIDGET_ID);
            if (container) return container;

            container = Bot.CreateElement('div', {
                id: commonKeys.WIDGET_ID,
                className: 'fbw-container fbw-hidden '.concat(containerId ? 'fbw-force-position-relative' : ''),
            });

            /** elements: Toggle Button */
            const toggleBtn = Bot.CreateElement('button', { className: 'fbw-toggle', title: Bot.t('toggle_title') }, [
                Bot.CreateElement('img', {
                    className: 'fbw-toggle-icon',
                    src: data.assets.images.botToggleOpenedIcon,
                }),
            ]);
            /** events for the toggle button are bound later */

            /** Panel */
            const panel = Bot.CreateElement('div', { className: 'fbw-panel' });
            /** Powered by icon in footer (shown only if a URL is provided) */
            const powered = Bot.CreateElement('div', { className: 'fbw-powered' }, [
                Bot.CreateElement('a', { href: 'https://sbx360.com', target: '_blank' }, [
                    Bot.CreateElement('img', { src: data.assets.images.botPoweredByIcon, alt: Bot.t('powered_by') }),
                ]),
                Bot.CreateElement('span', { className: 'fbw-powered-label', innerText: Bot.t('powered_by') }),
            ]);

            /** Closed-state mini panel with welcome and quick suggestions */
            /** elements */
            let closedPanel;
            const welcomeMsg = Bot.t('closed_welcome');
            if (welcomeMsg) {
                closedPanel = Bot.CreateElement('div', { className: 'fbw-closed' });

                const closedWelcome = Bot.CreateElement('div', {
                    className: 'fbw-closed-welcome',
                    innerText: Bot.t('closed_welcome'),
                });
                closedPanel.appendChild(closedWelcome);
            }

            /** elements: header and actions */
            const header = Bot.CreateElement('div', { className: 'fbw-header' }, [
                Bot.CreateElement('div', { className: 'fbw-header-main' }, [
                    Bot.CreateElement('div', { className: 'fbw-header-icon' }, [
                        Bot.CreateElement('img', {
                            src: data.assets.images.botHeaderIcon,
                            alt: 'Bot icon',
                        }),
                    ]),
                    Bot.CreateElement('div', { className: 'fbw-title' }, [
                        Bot.CreateElement('div', { className: 'fbw-name', innerText: Bot.t('header_title') }),
                        Bot.CreateElement('div', { className: 'fbw-desc', innerText: Bot.t('header_subtitle') }),
                    ]),
                ]),
                /** Options (vertical ellipsis) and Close actions wrapper */
                Bot.CreateElement('div', { className: 'fbw-header-actions' }, [
                    Bot.CreateElement('button', {
                        className: 'fbw-opts-btn',
                        title: Bot.t('header_options_title'),
                        innerHTML: data.assets.svg.botOptionsHeaderIcon,
                    }),
                    Bot.CreateElement('button', {
                        className: 'fbw-close',
                        title: Bot.t('header_close_title'),
                        innerText: '×',
                    }),
                ]),
            ]);
            /** events */
            header.querySelector('.fbw-close')?.addEventListener('click', () => Bot.toggleOpen(false));

            /** Build options menu in header */
            const optsBtn = header.querySelector('.fbw-opts-btn');
            const optsMenu = Bot.CreateElement('div', { className: 'fbw-opts-menu' }, [
                Bot.CreateElement('button', {
                    className: 'fbw-opts-item fbw-opts-expand',
                    type: 'button',
                    innerText: Bot.t('opts_expand'),
                }),
                Bot.CreateElement('button', {
                    className: 'fbw-opts-item fbw-opts-finalize',
                    type: 'button',
                    innerText: Bot.t('opts_finalize'),
                }),
            ]);
            header.appendChild(optsMenu);

            /**
             * Close the header options menu.
             */
            function closeMenu() {
                optsMenu.classList.remove('open');
            }

            /**
             * Toggle the visibility state of the header options menu.
             */
            function toggleMenu() {
                optsMenu.classList.toggle('open');
            }

            /**
             * Check whether the widget panel is currently expanded to full height/width.
             * @returns {boolean}
             */
            function isExpanded() {
                return container.classList.contains('fbw-expanded');
            }

            /**
             * Update the label of the expand/restore menu item based on current expanded state.
             */
            function updateExpandLabel() {
                const label = header.querySelector('.fbw-opts-expand');
                if (label) label.innerText = isExpanded() ? Bot.t('opts_restore') : Bot.t('opts_expand');
            }

            /**
             * Toggle expanded mode for the widget panel and keep the latest message visible.
             */
            function toggleExpand() {
                container.classList.toggle('fbw-expanded');
                updateExpandLabel();
                /** keep the latest message visible after resize */
                const b = container.querySelector('.fbw-body');
                try {
                    requestAnimationFrame(() => Bot.scrollToBottom(b));
                } catch {
                    Bot.scrollToBottom(b);
                }
            }

            optsMenu.querySelector('.fbw-opts-expand').addEventListener('click', () => {
                toggleExpand();
            });
            optsMenu.querySelector('.fbw-opts-finalize').addEventListener('click', () => {
                try {
                    state.twilio.conversation.sendMessage(Bot.t('exit_message_action'));
                } catch {
                    Bot.finalizeChat();
                } finally {
                    toggleMenu();
                }
            });

            /** events: header options menu */
            optsBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleMenu();
                updateExpandLabel();
            });
            document.addEventListener('click', (e) => {
                if (!optsMenu.contains(e.target) && e.target !== optsBtn) closeMenu();
            });
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') closeMenu();
            });

            const body = Bot.CreateElement('div', { className: 'fbw-body' });

            const footer = Bot.CreateElement('div', { className: 'fbw-footer' });

            panel.appendChild(header);
            panel.appendChild(body);
            panel.appendChild(footer);
            panel.appendChild(powered);

            /** append */
            container.appendChild(panel);
            if (closedPanel) container.appendChild(closedPanel);
            container.appendChild(toggleBtn);

            if (containerId) {
                const containerParent = document.getElementById(containerId);
                if (containerParent) {
                    containerParent.appendChild(container);
                }
            } else {
                document.body.appendChild(container);
            }

            /** events */
            toggleBtn.addEventListener('click', () => Bot.toggleOpen());

            return container;
        },

        /** create format accept to input file */
        getFilesFormatToInput(files) {
            const accept2 = files.reduce((acc, val) => {
                val = val.toLowerCase();
                if (val.includes('image')) {
                    acc += 'image/*,';
                } else if (val.includes('pdf')) {
                    acc += '.pdf,';
                } else if (val.includes('audio')) {
                    acc += 'audio/mpeg,';
                } else if (val.includes('docx')) {
                    acc += 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';
                } else if (val.includes('xlsx')) {
                    acc +=
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,';
                } else if (val.includes('csv')) {
                    acc += '.csv,';
                } else if (val.includes('text')) {
                    acc += 'text/plain,';
                } else if (val.includes('video')) {
                    acc += 'video/mp4,';
                }

                return acc;
            }, '');

            return accept2.substring(0, accept2.length - 1);
        },

        /**
         * Render the chat UI (transcript + input area) according to current state.
         * Decides whether to show onboarding questions or the active chat session.
         * @returns {Promise<void>}
         */
        async render() {
            const container = Content.ensureContainer();
            const body = Bot.QSelector('.fbw-body', container);
            const footer = Bot.QSelector('.fbw-footer', container);

            /** Header values may change after fetch */
            const nameEl = Bot.QSelector('.fbw-name', container);
            const descEl = Bot.QSelector('.fbw-desc', container);
            if (nameEl) nameEl.innerText = Bot.t('header_title');
            if (descEl) descEl.innerText = Bot.t('header_subtitle');

            /** Clear */
            body.innerHTML = '';
            footer.innerHTML = '';

            /** Chat area (always render chat UI; drive behavior via onboarding state) */
            /** elements */
            const transcript = Bot.CreateElement('div', { className: 'fbw-transcript', id: 'fbw-transcript' });
            /** Jump-to-bottom control removed per requirements */

            /** If no session and we haven't asked the first question yet, ask the current question (sender: session) */
            /** Onboarding: ask current question from questions_session */
            if (!state.session && !state.onboarding.asked) {
                state.onboarding.index = state.onboarding.index ?? 0;
                const q = state.questions_session[state.onboarding.index] || state.questions_session[0];
                const ask = q.question + (q.panel_description ? '\n\n' + q.panel_description : '');
                const botMsg = await Bot.addMessage('session', ask);
                transcript.appendChild(Content.messageBubble(botMsg, null, { animate: true }));
                state.onboarding.asked = true;
            }

            /** append */
            body.appendChild(transcript);
            Bot.scrollToBottom(body);

            /** Input area */
            const form = Bot.CreateElement('form', { className: 'fbw-chat-input' });

            /** Suggestions popup (hidden by default) at the top of the chat body */
            let suggestionsPopup;
            let chipsWrap;
            if (state.session) {
                suggestionsPopup = Bot.CreateElement('div', {
                    className: 'fbw-suggest-popup',
                    title: Bot.t('suggestions_title'),
                });
                const popupInner = Bot.CreateElement('div', { className: 'fbw-suggest-inner' });
                const popupHeader = Bot.CreateElement('div', {
                    className: 'fbw-suggest-header',
                    innerText: Bot.t('suggestions_title'),
                });
                const popupClose = Bot.CreateElement('button', {
                    type: 'button',
                    className: 'fbw-suggest-close',
                    innerText: '×',
                });
                popupClose.addEventListener('click', () => suggestionsPopup.classList.remove('open'));
                const headerWrap = Bot.CreateElement('div', { className: 'fbw-suggest-headrow' }, [
                    popupHeader,
                    popupClose,
                ]);
                chipsWrap = Bot.CreateElement('div', { className: 'fbw-body-chips' });
                popupInner.appendChild(headerWrap);
                popupInner.appendChild(chipsWrap);
                suggestionsPopup.appendChild(popupInner);
                body.appendChild(suggestionsPopup);
            }

            /** Top toolbar with file, microphone, call assessor, and suggestions toggle */
            const tools = Bot.CreateElement('div', { className: 'fbw-tools' });
            /** fbw-tools visible only when a Twilio conversation exists */
            if (!state.twilio || !state.twilio.conversation) {
                tools.style.display = 'none';
            }
            const suggestBtn = Bot.CreateElement('button', {
                className: 'fbw-tool-btn fbw-suggest-btn',
                type: 'button',
                title: Bot.t('suggestions_title'),
                innerHTML: data.assets.svg.botSuggestionIcon,
            });

            suggestBtn.addEventListener('click', () => {
                if (!suggestionsPopup) return;
                suggestionsPopup.classList.toggle('open');
            });

            const fileBtn = Bot.CreateElement('button', {
                className: 'fbw-tool-btn',
                type: 'button',
                id: 'file-btn',
                title: Bot.t('tool_attach_title'),
                innerHTML: data.assets.svg.botFileUploadIcon,
            });
            const micBtn = Bot.CreateElement('button', {
                className: 'fbw-tool-btn',
                type: 'button',
                id: 'mic-btn',
                title: Bot.t('tool_mic_title'),
                innerHTML: data.assets.svg.botMicrophoneIcon,
            });
            const callBtn = Bot.CreateElement('button', {
                className: 'fbw-tool-btn',
                type: 'button',
                id: 'call-assessor-btn',
                title: Bot.t('tool_call_title'),
                innerHTML: `${data.assets.svg.botPhoneAssessor}<span>${Bot.t('tool_call_title')}</span>`,
            });

            if (data.suggestions?.length > 0) {
                tools.appendChild(suggestBtn);
            }

            if (Object.values(data.haveFileButton).some((v) => v)) tools.appendChild(fileBtn);
            if (data.haveMicButton) tools.appendChild(micBtn);
            if (data.haveAssessorButton) tools.appendChild(callBtn);

            /** Help panel for onboarding question description */
            let helpPanel = null;

            /**
             * Get the current onboarding question (null when a session already exists).
             * @returns {{question:string, panel_description?:string, step?:number, type?:string, name?:string, placeholder?:string, error_message?:string}|null}
             */
            function getCurrentQuestion() {
                if (state.session) return null;
                const idx = state.onboarding?.index ?? 0;
                return state.questions_session[idx] || null;
            }

            /**
             * Refresh the help panel and input attributes based on the current onboarding question.
             * Updates placeholder, input type, required flag, and description panel.
             */
            function refreshHelpAndInput() {
                const q = getCurrentQuestion();
                if (!q) {
                    if (helpPanel) helpPanel.style.display = 'none';
                    /** Restore default input attributes when not in onboarding */
                    if (input) {
                        input.placeholder = Bot.t('input_placeholder');
                        input.type = 'text';
                        input.removeAttribute('pattern');
                        input.removeAttribute('maxlength');
                        input.removeAttribute('required');
                    }
                    return;
                }
                if (!helpPanel) {
                    helpPanel = Bot.CreateElement('div', { className: 'fbw-help' });
                }
                helpPanel.style.display = 'none';
                helpPanel.innerText = q.panel_description || '';
                input.placeholder = q.placeholder || Bot.t('input_placeholder');
                input.type = q.type === 'email' ? 'email' : 'text';
                /** Apply per-question constraints */
                if (q.name === 'name') {
                    /** Two words, letters only (supports common accented chars), max 15 each */
                    input.setAttribute('pattern', '^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{1,15}\\s+[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{1,15}$');
                    input.setAttribute('maxlength', '33');
                    input.setAttribute('required', 'true');
                } else if (q.name === 'phone') {
                    input.setAttribute('pattern', '^\\(\\d{3}\\)-\\d{3}-\\d{4}$');
                    input.removeAttribute('maxlength');
                    input.setAttribute('required', 'true');
                } else {
                    input.removeAttribute('pattern');
                    input.removeAttribute('maxlength');
                    if (q.required) {
                        input.setAttribute('required', 'true');
                    } else {
                        input.removeAttribute('required');
                    }
                }
            }

            const valueType = Object.entries(data.haveFileButton).reduce((acc, [key, value]) => {
                if (value) {
                    switch (key) {
                        case 'image':
                            acc.push('image');
                            break;
                        case 'pdf':
                            acc.push('pdf');
                            break;
                        case 'excel':
                            acc.push('xlsx');
                            break;
                        case 'word':
                            acc.push('docx');
                            break;
                        case 'csv':
                            acc.push('csv');
                            break;
                        default:
                            acc.push('text');
                            break;
                    }
                }
                return acc;
            }, []);

            /** Hidden file input */
            const fileInput = Bot.CreateElement('input', {
                type: 'file',
                style: 'display:none',
                accept: this.getFilesFormatToInput(valueType),
            });

            const input = Bot.CreateElement('input', {
                className: 'fbw-input fbw-input-message',
                name: 'message',
                placeholder: Bot.t('input_placeholder'),
                autocomplete: 'off',
                required: true,
            });
            const sendBtn = Bot.CreateElement('button', {
                className: 'fbw-btn fbw-btn-send',
                type: 'submit',
                title: Bot.t('send_title'),
                innerHTML: data.assets.svg.botSendMessageIcon,
            });
            sendBtn.setAttribute('aria-label', Bot.t('send_aria'));

            // Terms container (link + accept button)
            const termsContainer = Bot.CreateElement('div', { className: 'fbw-terms', style: 'display:none' });
            const termsLink = Bot.CreateElement('a', {
                href: data.policy_terms_url || '#',
                target: '_blank',
                rel: 'noopener noreferrer',
                innerText: Bot.t('terms_link_label'),
                className: 'fbw-terms-link',
            });
            const termsAccept = Bot.CreateElement('button', {
                type: 'button',
                className: 'fbw-btn fbw-btn-accept-terms',
                innerText: Bot.t('terms_accept_button'),
            });
            termsContainer.appendChild(termsLink);
            termsContainer.appendChild(termsAccept);

            form.appendChild(tools);
            /** help panel sits below tools during onboarding */
            refreshHelpAndInput();
            if (!state.session) {
                if (helpPanel) form.appendChild(helpPanel);
            }
            // term container should appear before send/input controls
            form.appendChild(termsContainer);
            form.appendChild(fileInput);
            form.appendChild(sendBtn);
            form.appendChild(input);

            // Render suggestion chips into fbw-body-chips if suggestions are provided
            if (chipsWrap && Array.isArray(data.suggestions) && data.suggestions.length > 0) {
                chipsWrap.innerHTML = '';
                data.suggestions.forEach((sugg) => {
                    if (typeof sugg !== 'string') return;
                    const chip = Bot.CreateElement('button', {
                        type: 'button',
                        className: 'fbw-chip',
                        innerText: sugg,
                    });
                    chip.addEventListener('click', () => {
                        try {
                            input.value = sugg;
                            input.focus();
                            // Trigger input event in case there are validators or listeners
                            input.dispatchEvent(new Event('input', { bubbles: true }));
                            // Close suggestions popup after picking a chip
                            if (suggestionsPopup) suggestionsPopup.classList.remove('open');
                            // Programmatically click send to submit the message
                            sendBtn.click();
                        } catch (e) {
                            console.warn('Suggestion chip click failed', e);
                        }
                    });
                    chipsWrap.appendChild(chip);
                });
            }

            function toggleTermsVisibility() {
                const q = getCurrentQuestion();
                const show = !!q && q.type === 'terms' && !state.session;
                termsContainer.style.display = show ? '' : 'none';
                // Hide text input when a term step is active
                input.style.display = show ? 'none' : '';
                sendBtn.style.display = show ? 'none' : '';
            }
            toggleTermsVisibility();

            // Accept Terms handler: advance onboarding or start a session
            termsAccept.addEventListener('click', async (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                if (termsAccept.classList.contains('fbw-loading')) return;
                termsAccept.classList.add('fbw-loading');
                if (state.session) return;
                const idx = state.onboarding.index ?? 0;
                const q = state.questions_session[idx] || state.questions_session[0];
                if (!q || q.type !== 'terms') return;
                state.onboarding.terms = true;

                const nextIdx = idx + 1;
                if (nextIdx < state.questions_session.length) {
                    state.onboarding.index = nextIdx;
                    state.onboarding.asked = false;
                    const nextQ = state.questions_session[nextIdx];
                    const askNext = nextQ.question + (nextQ.panel_description ? '\n\n' + nextQ.panel_description : '');
                    const m = await Bot.addMessage(
                        'session',
                        askNext.replaceAll('{name}', state.onboarding?.name || '{name}')
                    );
                    transcript.appendChild(Content.messageBubble(m, null, { animate: true }));
                    refreshHelpAndInput();
                    toggleTermsVisibility();
                    Bot.scrollToBottom(body);
                    return;
                }

                // If a term step is the last one, start the session immediately
                input.disabled = true;
                sendBtn.disabled = true;
                Bot.loadingMessage();
                try {
                    const phoneDigits = String(state.onboarding.phone || '').replace(/\D+/g, '');
                    const { data: dataTwilio, payload } = await Bot.startRemoteSession({
                        name: state.onboarding.name,
                        phone: phoneDigits,
                    });
                    state.session = {
                        name: state.onboarding.name,
                        phone: payload.phone,
                        startedAt: new Date().toISOString(),
                        api: { request: payload, response: dataTwilio },
                    };
                    Bot.saveSession(state.session);
                    Bot.sendEvent('chatSessionStarted', {
                        request: payload,
                    });
                    try {
                        await Bot.setupTwilioIfAvailable();
                    } catch {}
                    Bot.QSelector('.fbw-typing')?.remove();

                    if (Bot.t('welcome_template')) {
                        const welcome = await Bot.addMessage(
                            'system',
                            Bot.fmt(Bot.t('welcome_template'), { name: state.session.name })
                        );
                        transcript.appendChild(Content.messageBubble(welcome, null, { animate: true }));
                    }

                    state.onboarding = null;
                    if (helpPanel) helpPanel.style.display = 'none';
                    input.disabled = false;
                    sendBtn.disabled = false;
                    try {
                        input.focus();
                    } catch {}
                } catch (err) {
                    console.warn('Session start error', err);
                    Bot.sendEvent('chatSessionFailed', {
                        error: String(err && err.message ? err.message : err),
                        response: err && err.response ? err.response : null,
                    });
                    Bot.QSelector('.fbw-typing')?.remove();
                    const errMsg = await Bot.addMessage('bot', Bot.t('pre_error_generic'));
                    transcript.appendChild(Content.messageBubble(errMsg, null, { animate: true }));
                    input.disabled = false;
                    sendBtn.disabled = false;
                } finally {
                    if (data.withInitialMessage) {
                        const text = Bot.t('initial_message');
                        await state.twilio.conversation.sendMessage(text);
                        Bot.loadingMessage();
                        input.disabled = true;
                        sendBtn.disabled = true;
                    }
                    termsAccept.classList.remove('fbw-loading');
                    toggleTermsVisibility();
                }
            });

            /** events: input and tools */
            fileBtn.addEventListener('click', () => fileInput.click());
            fileInput.addEventListener('change', async () => {
                const files = Array.from(fileInput.files || []);
                if (files.length === 0) return;
                if (!state.session) {
                    fileInput.value = '';
                    return;
                }

                /** Show a local system note */
                const sys = await Bot.addMessage(
                    'system',
                    files.length === 1
                        ? Bot.fmt(Bot.t('attach_one'), { name: files[0].name || 'file' })
                        : Bot.fmt(Bot.t('attach_many'), { count: files.length })
                );
                transcript.appendChild(Content.messageBubble(sys, null, { animate: true }));
                Bot.scrollToBottom(body);

                try {
                    if (state.twilio && state.twilio.conversation) {
                        /** For simplicity send the first file; can be extended to multiple */
                        const first = files[0];
                        await Bot.sendMediaOrAttachment({ file: first, kind: 'file' });
                    }
                } catch (e) {
                    console.warn('Attachment send failed', e);
                } finally {
                    fileInput.value = '';
                }
            });

            /** Microphone recording */
            let mediaRecorder = null;
            let audioChunks = [];

            /**
             * Start microphone recording, collect audio chunks, and on stop send via Twilio if available.
             * Dispatches a legacy 'bot:audio' event with the recorded blob.
             * @returns {Promise<void>}
             */
            async function startRecording() {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    audioChunks = [];
                    mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.ondataavailable = (e) => {
                        if (e.data && e.data.size) audioChunks.push(e.data);
                    };
                    mediaRecorder.onstop = async () => {
                        try {
                            stream.getTracks().forEach((t) => t.stop());
                        } catch {}
                        const blob = new Blob(audioChunks, { type: 'audio/webm' });
                        /** If Twilio is active, send the recorded audio */
                        try {
                            if (state.twilio && state.twilio.conversation) {
                                const audioFile = new File([blob], 'twilio-audio.mp3', { type: 'audio/mpeg' });
                                await Bot.sendMediaOrAttachment({ file: audioFile, kind: 'audio' });
                            }
                        } catch (e) {
                            console.warn('Audio send failed', e);
                        }
                        const sysNote = await Bot.addMessage('system', Bot.t('mic_recorded'));
                        transcript.appendChild(Content.messageBubble(sysNote, null, { animate: true }));
                        Bot.scrollToBottom(body);
                    };
                    mediaRecorder.start();
                    micBtn.classList.add('recording');
                } catch (err) {
                    const mic = await Bot.addMessage('system', Bot.t('mic_denied'));
                    transcript.appendChild(Content.messageBubble(mic, null, { animate: true }));
                    Bot.scrollToBottom(body);
                }
            }

            /**
             * Stop an active MediaRecorder (if any) and clear the recording UI state.
             */
            function stopRecording() {
                try {
                    if (mediaRecorder && mediaRecorder.state !== 'inactive') mediaRecorder.stop();
                } finally {
                    micBtn.classList.remove('recording');
                }
            }

            micBtn.addEventListener('click', () => {
                if (!state.session) return;
                if (micBtn.classList.contains('recording')) {
                    stopRecording();
                } else {
                    startRecording();
                }
            });

            /** Call assessor */
            callBtn.addEventListener('click', async () => {
                if (!state.session) return;
                const sys = await Bot.addMessage('system', Bot.t('assessor_notified'));
                state.twilio.conversation.sendMessage(Bot.t('agent_message_action'));
                transcript.appendChild(Content.messageBubble(sys, null, { animate: true }));
                Bot.scrollToBottom(body);
                callBtn.classList.add('fbw-hidden');
            });

            /**
             * Remove all non-digit characters from a string.
             * @param {string} s - Input string that may contain formatting.
             * @returns {string} Digits-only string.
             */
            function onlyDigits(s) {
                return String(s || '').replace(/\D+/g, '');
            }

            /**
             * Format a US-style 10-digit phone number as (XXX)-XXX-XXXX while typing.
             * Non-digit characters are removed before formatting; the output is truncated to 10 digits.
             * @param {string} d - Raw input value.
             * @returns {string} Formatted value.
             */
            function formatPhone10(d) {
                const digits = onlyDigits(d).slice(0, 10);
                if (digits.length < 4) return digits;
                if (digits.length < 7) return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
                return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
            }

            /**
             * Validate that the input contains exactly 10 digits (US local number length).
             * @param {string} d - Raw input value.
             * @returns {boolean} True if 10 digits.
             */

            /** If collecting phone, live-format as the user types*/
            input.addEventListener('input', () => {
                const stepInput = getCurrentQuestion();

                if (stepInput) {
                    if (stepInput.required) {
                        input.setAttribute('required', 'true');
                    } else {
                        input.removeAttribute('required');
                    }
                    input.setAttribute('placeholder', stepInput.placeholder);
                    input.setAttribute('title', stepInput.error_message);

                    if (stepInput.regex.test(input.value)) {
                        input.removeAttribute('pattern');
                    } else {
                        input.setAttribute('pattern', stepInput.regex);
                    }
                }

                switch (!state.session) {
                    case stepInput?.step === 1:
                        break;
                    case stepInput?.step === 2:
                        const pos = input.selectionStart;
                        input.value = formatPhone10(input.value);
                        if (input.value.endsWith(')')) {
                            try {
                                input.setSelectionRange(pos, pos);
                            } catch {}
                        }
                        break;
                }
            });

            //send a message submitting
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                const text = input.value.trim();
                if (!text || input.disabled) return;
                // Validate assessor status: do not allow sending while assessor is active

                input.value = '';
                Bot.tryResumeAudio();

                /* If no session, run the onboarding dialog based on questions_session */
                if (!state.session) {
                    const idx = state.onboarding.index ?? 0;
                    const q = state.questions_session[idx] || state.questions_session[0];

                    let answer = text;
                    /* Render the user's answer bubble (non-persistent before session) */
                    const userMsg = await Bot.addMessage('user', answer);
                    Bot.sendEvent('userMessage', { text });
                    transcript.appendChild(Content.messageBubble(userMsg, null, { animate: true }));
                    Bot.scrollToBottom(body);

                    /* Validate a per-step if needed before saving/advancing */
                    if (q && q.name === 'name') {
                        const raw = answer.trim();
                        const hasGreeting = /(\b|\s)(hola|hello)(\b|\s)/i.test(raw);
                        /* Two words letters-only, 1-15 each (allow common accents) */
                        const nameRegex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{1,15}\s+[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{1,15}$/;
                        if (hasGreeting || !nameRegex.test(raw)) {
                            const warn = await Bot.addMessage('bot', Bot.t('q1_error_message'));
                            transcript.appendChild(Content.messageBubble(warn, null, { animate: true }));
                            Bot.scrollToBottom(body);
                            /* keep index unchanged and do not save invalid answer */
                            return;
                        }
                    }

                    if (idx === 0 && containerId) sessionStorage.setItem('name_user', answer);

                    /* Save answer to onboarding state by name */
                    if (q && q.name) state.onboarding[q.name] = answer;

                    /* Advance to next question or start session */
                    const nextIdx = idx + 1;
                    if (nextIdx < state.questions_session.length) {
                        state.onboarding.index = nextIdx;
                        state.onboarding.asked = false;
                        const nextQ = state.questions_session[nextIdx];
                        const askNext =
                            nextQ.question + (nextQ.panel_description ? '\n\n' + nextQ.panel_description : '');
                        const m = await Bot.addMessage(
                            'session',
                            askNext.replaceAll('{name}', state.onboarding?.name || '{name}')
                        );
                        transcript.appendChild(Content.messageBubble(m, null, { animate: true }));
                        refreshHelpAndInput();
                        toggleTermsVisibility();
                        Bot.scrollToBottom(body);
                        return;
                    }

                    /* Collected all, start remote session */

                    if (!state.assessorActive) {
                        input.disabled = true;
                        sendBtn.disabled = true;
                        Bot.loadingMessage();
                    }

                    try {
                        const phoneDigits = String(state.onboarding.phone || '').replace(/\D+/g, '');
                        const { data: dataTwilio, payload } = await Bot.startRemoteSession({
                            name: state.onboarding.name,
                            phone: phoneDigits,
                        });
                        state.session = {
                            name: state.onboarding.name,
                            phone: payload.phone,
                            startedAt: new Date().toISOString(),
                            api: { request: payload, response: dataTwilio },
                        };
                        Bot.saveSession(state.session);
                        Bot.sendEvent('chat_session_started', { session: payload });
                        /* Attempt Twilio setup once the session is ready */
                        try {
                            await Bot.setupTwilioIfAvailable();
                        } catch {}
                        Bot.QSelector('.fbw-typing')?.remove();
                        const welcome = await Bot.addMessage(
                            'system',
                            Bot.fmt(Bot.t('welcome_template'), { name: state.session.name })
                        );
                        transcript.appendChild(Content.messageBubble(welcome, null, { animate: true }));
                        state.onboarding = null;
                        if (helpPanel) helpPanel.style.display = 'none';
                        input.disabled = false;
                        sendBtn.disabled = false;
                        try {
                            input.focus();
                        } catch {}
                        if (state.pendingMessage) {
                            input.value = state.pendingMessage;
                            state.pendingMessage = null;
                        }
                        /* Restore default input attributes for chat session */
                        refreshHelpAndInput();
                    } catch (err) {
                        console.error('Failed to start chat session', err);
                        Bot.sendEvent('chatSessionFailed', {
                            error: String(err && err.message ? err.message : err),
                            response: err && err.response ? err.response : null,
                        });
                        Bot.QSelector('.fbw-typing')?.remove();
                        const m = await Bot.addMessage('bot', Bot.t('pre_error_generic'));
                        transcript.appendChild(Content.messageBubble(m, null, { animate: true }));
                        input.disabled = false;
                        sendBtn.disabled = false;
                        try {
                            input.focus();
                        } catch {}
                    }
                    return;
                }

                /* Normal chat flow when a session exists */
                if (state.session) {
                    /* Persist and render the user's message in session mode */

                    /* If Twilio conversation is available, send via Twilio and skip the local fake reply */
                    if (state.twilio && state.twilio.conversation) {
                        if (!state.assessorActive) {
                            input.disabled = true;
                            sendBtn.disabled = true;
                        }
                        try {
                            state.twilio.pendingUserBodies.push(text);
                            await state.twilio.conversation.sendMessage(text);
                            if (!state.assessorActive) {
                                input.disabled = true;
                                sendBtn.disabled = true;
                                Bot.loadingMessage();
                            }
                        } catch (err) {
                            console.warn('Twilio send error', err);
                            input.disabled = false;
                            sendBtn.disabled = false;
                        } finally {
                            try {
                                input.focus();
                            } catch {}
                        }
                    }
                }
            });

            footer.appendChild(form);
        },
    };

    /**
     * Bootstrap the widget: load styles, restore the session, set up Twilio (if any),
     * create the container, and render the UI.
     * @returns {Promise<void>}
     */
    async function init() {
        // Prevent duplicate initialization if the script is injected/ran more than once
        if (!containerId) {
            try {
                const g = typeof window !== 'undefined' ? window : globalThis;
                if (g.__formatScript2_init_done) return;
                g.__formatScript2_init_done = true;
            } catch {}
        }
        /**
         *  Load fonts and styles first (no HTML <link> needed)
         */
        await Bot.ensureFontsAndStyles();

        /** Load session if exists */
        state.session = Bot.loadSession();

        /** If a prior session exists, attempt Twilio setup (sid/token validation happens inside) */
        try {
            //need .then
            Bot.setupTwilioIfAvailable().then();
        } catch {}

        /** Prepare a container immediately */
        Content.ensureContainer();

        /** Fetch config then render */
        await Content.render();
        try {
            Bot.sendEvent('botStarted', {
                openCloseChat: (open) => Bot.toggleOpen(typeof open === 'boolean' ? open : undefined),
                onFinishChat: () => Bot.finalizeChat(),
                onAssessorRequest: () => {
                    try {
                        if (state.twilio?.conversation) {
                            state.twilio.conversation.sendMessage(Bot.t('agent_message_action'));
                        }
                    } catch {}
                },
            });
        } catch {}

        // Listen for external botEvent commands (login/logout/sendMessage, etc.)
        Bot.on(window, 'botEvent', async (event) => {
            try {
                const detail = event?.detail || {};
                const type = detail.type || detail.event || '';
                switch (type) {
                    case 'login': {
                        // Prefill onboarding state and jump to terms step to continue chat
                        const name = detail.name || detail.info?.name || '';
                        const email = detail.email || detail.info?.email || '';
                        const phone = detail.phone || detail.info?.phone || '';
                        const metadata = detail.metadata || detail.info?.metadata || {};
                        // Reset any existing session and force onboarding to terms
                        state.session = null;
                        state.onboarding = {
                            index: 2, // third item (terms)
                            asked: false,
                            name: name || state.onboarding?.name || '',
                            phone: phone || state.onboarding?.phone || '',
                            email,
                            metadata,
                        };
                        await Content.render();
                        break;
                    }

                    case 'logout': {
                        try {
                            if (state.twilio?.conversation) {
                                await state.twilio.conversation.sendMessage(Bot.t('exit_message_action'));
                            } else {
                                Bot.finalizeChat();
                            }
                        } catch {
                            Bot.finalizeChat();
                        }
                        break;
                    }
                    case 'sendMessage': {
                        // Optional passthrough for v1 compatibility
                        const message = detail.message || detail.info?.message || '';
                        if (!message) break;
                        const container = document.getElementById(commonKeys.WIDGET_ID);
                        const input = container?.querySelector('.fbw-input-message');
                        if (input) input.value = message;
                        const form = container?.querySelector('.fbw-chat-input');
                        form?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                        break;
                    }

                    case 'toggleChatOpen':
                        Bot.toggleOpen(true);
                        break;

                    case 'toggleChatClose':
                        Bot.toggleOpen(false);
                }
            } catch (e) {
                console.warn('botEvent handler failed', e);
            }
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}

function getInfoFormatted(data) {
    const { baseUrl, agentId, withMicrophone, withAssessor, withAttachment, withInitialMessage, urlFiles, dataBot } =
        data;

    const {
        look_and_feel_chat: { extra_config, agent_name, suggested_message },
    } = dataBot;

    return {
        haveAssessorButton: withAssessor,
        haveMicButton: withMicrophone,
        haveFileButton: withAttachment || {},
        withInitialMessage,
        agentId,
        agentName: agent_name,
        identify: 'rag_iue',
        policy_terms_url: data.policy_terms_url || extra_config?.policy_terms_url || '',
        config: {
            locationUrl: 'https://ipapi.co/json',
            baseUrl,
            sessionPath: '/api/v2/chat',
            stylesLinks: {
                variables: data.urlCss,
            },
            urlFiles,
        },
        assets: {
            images: {
                botHeaderIcon: extra_config?.logo_header || logo_placeholder,
                botPoweredByIcon: 'https://sbx.sbx360.com/www/democrm/ai-agent/images/sbx_360.ico',
                botToggleOpenedIcon:
                    dataBot.avatar ||
                    'data:image/svg+xml;base64,PHN2ZyB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgZmlsbD0iY3VycmVudENvbG9yIiB2aWV3Qm94PSIwIDAgMjU2LjAwMDk4IDI1Ni4wMDA5OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjU2LjAwMDk4IiAgaGVpZ2h0PSIyNTYuMDAwOTgiID48ZyBmaWxsPSIjRkZGRkZGIj48cGF0aCBkPSJNMjMyLjAwMiw2NC4wMDI5M3YxMjhhMTYuMDIwODQsMTYuMDIwODQsMCwwLDEtMTYsMTZsLTEzMy45NTMxMi4zNzUtMzEuNzUsMjYuNjk1MzFhMTUuODY5NjgsMTUuODY5NjgsMCwwLDEtMTAuMjUsMy43NzM0NCwxNi4xMTI1OCwxNi4xMTI1OCwwLDAsMS02Ljc5Njg4LTEuNTE1NjMsMTUuODYxNCwxNS44NjE0LDAsMCwxLTkuMjUtMTQuNTA3ODFWNjQuMDAyOTNhMTYuMDIwODUsMTYuMDIwODUsMCwwLDEsMTYtMTZoMTc2QTE2LjAyMDg0LDE2LjAyMDg0LDAsMCwxLDIzMi4wMDIsNjQuMDAyOTNaIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+PC9nPjwvc3ZnPg==',
            },
        },
        suggestions: suggested_message.length ? suggested_message : [],
        roles_options: extra_config.roles_options ?? [],
        role_title: extra_config?.role_title || '',
        role_message: extra_config?.role_message || '',
        texts: buildTexts(extra_config || {}),
    };
}

function formatInitBot(data, containerBotId) {
    const urlCss = data.urlCss;
    const config = getInfoFormatted(data);

    if (urlCss !== null && urlCss === undefined) {
        const css = formatCss(data.dataBot.look_and_feel_chat.extra_config, data.dataBot.id);
        const cssStyle = document.createElement('style');
        cssStyle.innerHTML = css;
        document.head.appendChild(cssStyle);
    }

    return `
    //${data.dataBot.look_and_feel_chat.extra_config.version || ''}
    ((data) => {
        data.assets.svg = {
                botOptionsHeaderIcon:
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
                botSuggestionIcon:
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M9 18h6M10 22h4M2 12a10 10 0 1 0 20 0A10 10 0 0 0 2 12Zm5-1a5 5 0 0 1 10 0c0 1.86-1.06 3.47-2.6 4.28-.22.12-.4.3-.5.52-.3.58-.9 1.2-1.9 1.2s-1.6-.62-1.9-1.2a1.2 1.2 0 0 0-.5-.52A4.996 4.996 0 0 1 7 11Z"/></svg>',
                botFileUploadIcon:
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M21.44 11.05l-8.49 8.49a5.5 5.5 0 0 1-7.78-7.78l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.19 9.19a1.5 1.5 0 0 1-2.12-2.12l8.49-8.49"/></svg>',
                botMicrophoneIcon:
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M12 1a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>',
                botPhoneAssessor:
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.31 1.77.57 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.09a2 2 0 0 1 2.11-.45c.84.26 1.71.45 2.61.57A2 2 0 0 1 22 16.92z"/></svg>',
                botSendMessageIcon:
                    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>',
                botHeaderMessageIcon:
                    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="none" d="M0 0h24v24H0z"></path> <path d="M4.929 19.071A9.969 9.969 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929zM11 6v12h2V6h-2zM7 9v6h2V9H7zm8 0v6h2V9h-2z"></path> </g> </g></svg>',
        };
        const initBot = ${botScriptInit};
        initBot(data, ${containerBotId ? `'${containerBotId}'` : 'null'});
    })(${JSON.stringify(config)})`;
}

export { formatInitBot };
